import React from 'react';

export const PlainDownArrow = ({ styles }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7578 5.25879L8.0918 11.9248L1.4248 5.25879L2.6084 4.0752L8.0918 9.55859L13.5752 4.0752L14.7578 5.25879Z"
      fill="#424A5C"
    />
  </svg>
);
export const PlainRightArrow = ({ styles }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g mask="url(#mask0_6018_104)">
      <path
        d="M5.87257 14.6667L4.66663 13.4833L10.2547 7.99999L4.66663 2.51666L5.87257 1.33333L12.6666 7.99999L5.87257 14.6667Z"
        fill="#424A5C"
      />
    </g>
  </svg>
);

export const Dots = ({ color = 'currentColor', ...props }) => (
  <svg
    color={color}
    width={16}
    height={16}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M0 0h4v4H0zM0 6h4v4H0zM0 12h4v4H0zM6 0h4v4H6zM6 6h4v4H6zM6 12h4v4H6zM12 0h4v4h-4zM12 6h4v4h-4zM12 12h4v4h-4z" />
    </g>
  </svg>
);

export const MoreInfoRightArrow = ({
  color = 'currentColor',
  isClub,
  ...props
}) => (
  <svg
    width={isClub ? '8' : '18'}
    height={isClub ? '12' : '18'}
    viewBox={isClub ? '0 0 8 12' : '0 0 18 18'}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d={
        isClub
          ? 'M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z'
          : 'M0 18L0 0L9 0V2L2 2L2 16L16 16L16 9H18V18L0 18ZM6.7 12.7L5.3 11.3L14.6 2L11 2V0L18 0V7L16 7L16 3.4L6.7 12.7Z'
      }
      fill="white"
    />
  </svg>
);

export const FilterSwitchSVG = () => (
  <svg
    width="20"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.23333 15.8666V13.1333H0V11.1333H6.23333V8.3333H8.23333V15.8666H6.23333ZM10.2333 13.1333V11.1333H24V13.1333H10.2333ZM15.7667 7.6333V0.133301H17.7667V2.86663H24V4.86663H17.7667V7.6333H15.7667ZM0 4.86663V2.86663H13.7667V4.86663H0Z"
      fill="#E1261C"
    />
  </svg>
);

export const ListOrMapSVG = ({ listOrMap }) => (
  <svg
    id="viewSVG"
    width="16"
    height={listOrMap === 'list' ? '11' : '16'}
    viewBox={listOrMap === 'list' ? '0 0 16 11' : '0 0 16 16'}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d={
        listOrMap === 'list'
          ? 'M0 11V9.16667H10.6667V11H0ZM0 6.41667V4.58333H16V6.41667H0ZM0 1.83333V0H16V1.83333H0Z'
          : 'M10.4029 15.9708L5.20146 14.111L1.17033 15.7051C0.881359 15.8232 0.614062 15.79 0.368437 15.6055C0.122812 15.421 0 15.1737 0 14.8638V2.46481C0 2.27292 0.0541819 2.10317 0.162546 1.95556C0.27091 1.80796 0.419007 1.69725 0.606837 1.62345L5.20146 0.0292969L10.4029 1.88914L14.4341 0.294989C14.723 0.176904 14.9903 0.210115 15.236 0.394623C15.4816 0.579132 15.6044 0.826373 15.6044 1.13635V13.5353C15.6044 13.7272 15.5502 13.8969 15.4418 14.0446C15.3335 14.1922 15.1854 14.3029 14.9976 14.3767L10.4029 15.9708ZM9.53602 13.801V3.43901L6.06837 2.19912V12.5611L9.53602 13.801ZM11.2698 13.801L13.8706 12.9154V2.42053L11.2698 3.43901V13.801ZM1.73382 13.5796L4.33455 12.5611V2.19912L1.73382 3.08476V13.5796Z'
      }
      fill={listOrMap === 'list' ? '#DD221A' : '#E1261C'}
    />
  </svg>
);

export const DivLine = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={248}
    height={1}
    viewBox="0 0 262 1"
    fill="none"
  >
    <line y1="0.5" x2="262" y2="0.5" stroke="#ECEEF3" />
  </svg>
);

export const RedLine = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={2}
    viewBox="0 0 8 2"
    fill="none"
  >
    <line
      x1="8"
      y1="1"
      x2="-8.74228e-08"
      y2="0.999999"
      stroke="#E1261C"
      strokeWidth="2"
    />
  </svg>
);

export const QuickLine = ({ color = 'currentColor', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 3" fill="none">
    <line
      class="quickLine"
      x1="1.5"
      y1="1.5"
      x2="18.5"
      y2="1.5"
      stroke="#E1261C"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const QuickDots = ({ color = 'currentColor', ...props }) => (
  <svg
    width="46"
    height="9"
    viewBox="0 0 46 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="quickDots"
      d="M1.59871 1.67783C0.861134 2.4601 0.5 3.40111 0.5 4.5C0.5 5.59889 0.861133 6.5399 1.59871 7.32217C2.33736 8.1056 3.23806 8.5 4.3 8.5C5.36194 8.5 6.26264 8.1056 7.0013 7.32217C7.73887 6.5399 8.1 5.59889 8.1 4.5C8.1 3.40111 7.73887 2.4601 7.0013 1.67783C6.26264 0.894401 5.36194 0.499998 4.3 0.499998C3.23806 0.499998 2.33736 0.894401 1.59871 1.67783ZM20.2987 1.67783C19.5611 2.4601 19.2 3.40111 19.2 4.5C19.2 5.59889 19.5611 6.5399 20.2987 7.32217C21.0374 8.1056 21.9381 8.5 23 8.5C24.0619 8.5 24.9626 8.1056 25.7013 7.32217C26.4389 6.5399 26.8 5.59889 26.8 4.5C26.8 3.40111 26.4389 2.4601 25.7013 1.67783C24.9626 0.894402 24.0619 0.499999 23 0.499999C21.9381 0.499999 21.0374 0.894401 20.2987 1.67783ZM38.9987 1.67783C38.2611 2.4601 37.9 3.40111 37.9 4.5C37.9 5.59889 38.2611 6.5399 38.9987 7.32217C39.7374 8.1056 40.6381 8.5 41.7 8.5C42.7619 8.5 43.6626 8.1056 44.4013 7.32217C45.1389 6.5399 45.5 5.59889 45.5 4.5C45.5 3.40111 45.1389 2.4601 44.4013 1.67783C43.6626 0.894402 42.7619 0.5 41.7 0.5C40.6381 0.5 39.7374 0.894402 38.9987 1.67783Z"
      fill="#E1261C"
      stroke="#E1261C"
    />
  </svg>
);

export const Chevron = ({ color = 'currentColor', ...props }) => (
  <svg
    color={color}
    width={25}
    height={24}
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="transparent" fillRule="evenodd">
      <path d="M24.5 0H.5v24h24z" />
      <path fill={color} d="M9.09 7.41L13.67 12l-4.58 4.59L10.5 18l6-6-6-6z" />
    </g>
  </svg>
);

export const AccordionUpArrow = ({
  color = 'currentColor',
  viewBox = '0 0 28 28',
  ...props
}) => (
  <svg
    width="28"
    height="28"
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33366 13.9998C3.33366 8.1088 8.10929 3.33317 14.0003 3.33317C19.8914 3.33317 24.667 8.1088 24.667 13.9998C24.667 19.8909 19.8914 24.6665 14.0003 24.6665C8.10929 24.6665 3.33366 19.8909 3.33366 13.9998Z"
      fill="#041C39"
      stroke="#041C39"
      strokeWidth="2"
    />
    <mask
      id="mask0"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="7"
      width="12"
      height="12"
    >
      <rect
        x="20"
        y="19"
        width="12"
        height="12"
        transform="rotate(-180 20 19)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M18.9316 15.0563L18.0441 15.9438L13.9316 11.8313L9.81914 15.9438L8.93164 15.0563L13.9316 10.0563L18.9316 15.0563Z"
        fill="white"
      />
    </g>
  </svg>
);

export const AccordionDownArrow = ({
  color = 'currentColor',
  viewBox = '0 0 28 28',
  ...props
}) => (
  <svg
    width="28"
    height="28"
    viewBox={viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="13.9997"
      cy="14.0002"
      r="10.6667"
      stroke="#041C39"
      strokeWidth="2"
    />
    <mask
      id="mask0"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="7"
      y="8"
      width="14"
      height="15"
    >
      <rect x="7" y="8.1665" width="14" height="14" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0)">
      <path
        d="M8.24642 12.7673L9.28183 11.7319L14.0798 16.5299L18.8777 11.7319L19.9131 12.7674L14.0798 18.6007L8.24642 12.7673Z"
        fill="#041C39"
      />
    </g>
  </svg>
);

export const DownArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
  >
    <rect
      x="1"
      y="1"
      width="40"
      height="40"
      rx="3"
      transform="matrix(4.37114e-08 1 1 -4.37114e-08 4.37114e-08 -4.37114e-08)"
      fill="white"
      fillOpacity="0.1"
    />
    <rect
      x="1"
      y="1"
      width="40"
      height="40"
      rx="3"
      transform="matrix(4.37114e-08 1 1 -4.37114e-08 4.37114e-08 -4.37114e-08)"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M14.4375 23.625L21 17.0625L27.5625 23.625"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UpArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
  >
    <rect
      x="-1"
      y="-1"
      width="40"
      height="40"
      rx="3"
      transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 40 40)"
      fill="white"
      fillOpacity="0.1"
    />
    <rect
      x="-1"
      y="-1"
      width="40"
      height="40"
      rx="3"
      transform="matrix(-1.19249e-08 -1 -1 1.19249e-08 40 40)"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M27.5625 18.375L21 24.9375L14.4375 18.375"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DisabledDownArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
  >
    <rect
      opacity="0.5"
      width="40"
      height="40"
      rx="4"
      transform="matrix(-1 0 0 1 41 1)"
      fill="#B7C5E9"
    />
    <path
      d="M27.5625 18.375L21 24.9375L14.4375 18.375"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LocationIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M7.33353 15.3002V13.9669C5.94464 13.8113 4.75297 13.2363 3.75853 12.2419C2.76408 11.2474 2.18908 10.0557 2.03353 8.66686H0.700195V7.33353H2.03353C2.18908 5.94464 2.76408 4.75297 3.75853 3.75853C4.75297 2.76408 5.94464 2.18908 7.33353 2.03353V0.700195H8.66686V2.03353C10.0557 2.18908 11.2474 2.76408 12.2419 3.75853C13.2363 4.75297 13.8113 5.94464 13.9669 7.33353H15.3002V8.66686H13.9669C13.8113 10.0557 13.2363 11.2474 12.2419 12.2419C11.2474 13.2363 10.0557 13.8113 8.66686 13.9669V15.3002H7.33353ZM8.00019 12.6669C9.28908 12.6669 10.3891 12.2113 11.3002 11.3002C12.2113 10.3891 12.6669 9.28908 12.6669 8.00019C12.6669 6.71131 12.2113 5.61131 11.3002 4.7002C10.3891 3.78908 9.28908 3.33353 8.00019 3.33353C6.71131 3.33353 5.61131 3.78908 4.7002 4.7002C3.78908 5.61131 3.33353 6.71131 3.33353 8.00019C3.33353 9.28908 3.78908 10.3891 4.7002 11.3002C5.61131 12.2113 6.71131 12.6669 8.00019 12.6669ZM8.00019 10.6669C7.26686 10.6669 6.63908 10.4058 6.11686 9.88353C5.59464 9.36131 5.33353 8.73353 5.33353 8.00019C5.33353 7.26686 5.59464 6.63908 6.11686 6.11686C6.63908 5.59464 7.26686 5.33353 8.00019 5.33353C8.73353 5.33353 9.36131 5.59464 9.88353 6.11686C10.4058 6.63908 10.6669 7.26686 10.6669 8.00019C10.6669 8.73353 10.4058 9.36131 9.88353 9.88353C9.36131 10.4058 8.73353 10.6669 8.00019 10.6669ZM8.00019 9.33353C8.36686 9.33353 8.68075 9.20297 8.94186 8.94186C9.20297 8.68075 9.33353 8.36686 9.33353 8.00019C9.33353 7.63353 9.20297 7.31964 8.94186 7.05853C8.68075 6.79742 8.36686 6.66686 8.00019 6.66686C7.63353 6.66686 7.31964 6.79742 7.05853 7.05853C6.79742 7.31964 6.66686 7.63353 6.66686 8.00019C6.66686 8.36686 6.79742 8.68075 7.05853 8.94186C7.31964 9.20297 7.63353 9.33353 8.00019 9.33353Z"
      fill="#B7C5E9"
    />
  </svg>
);

export const LocationSearchDefaultIcon = ({
  color = 'currentColor',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    //fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.54 22.351L11.61 22.391L11.638 22.407C11.749 22.467 11.8733 22.4985 11.9995 22.4985C12.1257 22.4985 12.25 22.467 12.361 22.407L12.389 22.392L12.46 22.351C12.8511 22.1191 13.2328 21.8716 13.604 21.609C14.5651 20.9305 15.463 20.1667 16.287 19.327C18.231 17.337 20.25 14.347 20.25 10.5C20.25 8.31196 19.3808 6.21354 17.8336 4.66637C16.2865 3.11919 14.188 2.25 12 2.25C9.81196 2.25 7.71354 3.11919 6.16637 4.66637C4.61919 6.21354 3.75 8.31196 3.75 10.5C3.75 14.346 5.77 17.337 7.713 19.327C8.53664 20.1667 9.43427 20.9304 10.395 21.609C10.7666 21.8716 11.1485 22.1191 11.54 22.351ZM12 13.5C12.7956 13.5 13.5587 13.1839 14.1213 12.6213C14.6839 12.0587 15 11.2956 15 10.5C15 9.70435 14.6839 8.94129 14.1213 8.37868C13.5587 7.81607 12.7956 7.5 12 7.5C11.2044 7.5 10.4413 7.81607 9.87868 8.37868C9.31607 8.94129 9 9.70435 9 10.5C9 11.2956 9.31607 12.0587 9.87868 12.6213C10.4413 13.1839 11.2044 13.5 12 13.5Z"
      fill="#DD221A"
    />
  </svg>
);

export const CoffeeIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={20}
    viewBox="0 0 22 20"
    fill="none"
    {...props}
  >
    <path
      d="M15 3V11C15 11.5304 14.7893 12.0391 14.4142 12.4142C14.0391 12.7893 13.5304 13 13 13H7C6.46957 13 5.96086 12.7893 5.58579 12.4142C5.21071 12.0391 5 11.5304 5 11V3H15ZM19 1H3V11C3 12.0609 3.42143 13.0783 4.17157 13.8284C4.92172 14.5786 5.93913 15 7 15H13C14.0609 15 15.0783 14.5786 15.8284 13.8284C16.5786 13.0783 17 12.0609 17 11V8H19C19.5304 8 20.0391 7.78929 20.4142 7.41421C20.7893 7.03914 21 6.53043 21 6V3C21 2.46957 20.7893 1.96086 20.4142 1.58579C20.0391 1.21071 19.5304 1 19 1ZM17 6V3H19V6H17ZM19 17H1V19H19V17Z"
      fill="#ECEEF3"
      stroke="#5B6885"
    />
  </svg>
);

export const CarIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_2786_5232)">
      <path
        d="M4.14145 18.8371L4.16429 18.3376L3.64145 18.3137V18.8371V20.1168C3.64145 20.8947 3.0381 21.4944 2.32073 21.4944C1.60431 21.4944 1 20.8901 1 20.1168V12.9485C1.00115 12.9397 1.00274 12.9281 1.00485 12.9139C1.01109 12.8721 1.02182 12.8082 1.03908 12.7271C1.07372 12.5644 1.13403 12.3354 1.2355 12.0777C1.43971 11.5591 1.7999 10.9503 2.42764 10.5131L2.56268 10.4191L2.61548 10.2632L4.62354 4.33469C4.62884 4.32327 4.63722 4.30564 4.64872 4.28265C4.67328 4.23354 4.71188 4.16041 4.765 4.07129C4.8718 3.89212 5.03418 3.65359 5.25504 3.4166C5.69674 2.94264 6.34556 2.5 7.24644 2.5H7.25915H7.27187H7.2846H7.29734H7.31009H7.32286H7.33564H7.34842H7.36122H7.37403H7.38685H7.39968H7.41252H7.42537H7.43824H7.45111H7.46399H7.47688H7.48978H7.50269H7.51561H7.52854H7.54147H7.55442H7.56738H7.58034H7.59331H7.60629H7.61928H7.63228H7.64528H7.65829H7.67131H7.68434H7.69737H7.71041H7.72346H7.73651H7.74958H7.76264H7.77572H7.7888H7.80188H7.81498H7.82807H7.84118H7.85429H7.8674H7.88052H7.89365H7.90678H7.91991H7.93305H7.9462H7.95935H7.9725H7.98565H7.99882H8.01198H8.02515H8.03832H8.05149H8.06467H8.07785H8.09104H8.10422H8.11741H8.13061H8.1438H8.157H8.17019H8.18339H8.1966H8.2098H8.22301H8.23621H8.24942H8.26263H8.27584H8.28905H8.30226H8.31547H8.32868H8.3419H8.35511H8.36832H8.38153H8.39474H8.40795H8.42116H8.43437H8.44758H8.46079H8.47399H8.4872H8.5004H8.5136H8.5268H8.54H8.55319H8.56639H8.57958H8.59276H8.60595H8.61913H8.63231H8.64549H8.65866H8.67183H8.68499H8.69816H8.71131H8.72447H8.73762H8.75076H8.76391H8.77704H8.79017H8.8033H8.81642H8.82954H8.84265H8.85576H8.86886H8.88195H8.89504H8.90812H8.9212H8.93427H8.94734H8.96039H8.97344H8.98649H8.99952H9.01255H9.02557H9.03859H9.05159H9.06459H9.07759H9.09057H9.10354H9.11651H9.12947H9.14242H9.15536H9.16829H9.18121H9.19413H9.20703H9.21992H9.23281H9.24568H9.25855H9.27141H9.28425H9.29708H9.30991H9.32272H9.33552H9.34832H9.3611H9.37387H9.38662H9.39937H9.4121H9.42483H9.43754H9.45024H9.46292H9.4756H9.48826H9.50091H9.51355H9.52617H9.53878H9.55138H9.56396H9.57653H9.58909H9.60163H9.61416H9.62667H9.63917H9.65166H9.66413H9.67658H9.68902H9.70145H9.71386H9.72626H9.73864H9.75101H9.76335H9.77569H9.78801H9.80031H9.81259H9.82486H9.83711H9.84935H9.86157H9.87377H9.88595H9.89812H9.91027H9.9224H9.93452H9.94661H9.95869H9.97075H9.98279H9.99482H10.0068H10.0188H10.0308H10.0427H10.0547H10.0666H10.0785H10.0903H10.1022H10.114H10.1258H10.1376H10.1494H10.1611H10.1729H10.1846H10.1963H10.2079H10.2196H10.2312H10.2428H10.2544H10.2659H10.2775H10.289H10.3005H10.3119H10.3234H10.3348H10.3462H10.3576H10.369H10.3803H10.3916H10.4029H10.4142H10.4254H10.4366H10.4478H10.459H10.4701H10.4812H10.4923H10.5034H10.5144H10.5255H10.5364H10.5474H10.5584H10.5693H10.5802H10.591H10.6019H10.6127H10.6235H10.6342H10.645H10.6557H10.6663H10.677H10.6876H10.6982H10.7088H10.7193H10.7298H10.7403H10.7508H10.7612H10.7716H10.782H10.7923H10.8027H10.8129H10.8232H10.8334H10.8436H10.8538H10.8639H10.874H10.8841H10.8942H10.9042H10.9142H10.9241H10.9341H10.944H10.9538H10.9637H10.9735H10.9832H10.993H11.0027H11.0124H11.022H11.0316H11.0412H11.0507H11.0603H11.0697H11.0792H11.0886H11.098H11.1073H11.1167H11.1259H11.1352H11.1444H11.1536H11.1627H11.1718H11.1809H11.19H11.199H11.2079H11.2169H11.2258H11.2347H11.2435H11.2523H11.261H11.2698H11.2785H11.2871H11.2957H11.3043H11.3129H11.3214H11.3298H11.3383H11.3467H11.355H11.3633H11.3716H11.3799H11.3881H11.3962H11.4044H11.4125H11.4205H11.4285H11.4365H11.4444H11.4523H11.4602H11.468H11.4758H11.4835H11.4912H11.4989H11.5065H11.5141H11.5216H11.5291H11.5366H11.544H11.5514H11.5587H11.566H11.5733H11.5805H11.5877H11.5948H11.6019H11.6089H11.6159H11.6229H11.6298H11.6367H11.6435H11.6503H11.657H11.6637H11.6704H11.677H11.6836H11.6901H11.6966H11.703H11.7094H11.7158H11.7221H11.7283H11.7346H11.7407H11.7469H11.7529H11.759H11.765H11.7709H11.7768H11.7826H11.7885H11.7942H11.7999H11.8056H11.8112H11.8168H11.8223H11.8278H11.8332H11.8386H11.8439H11.8492H11.8545H11.8597H11.8648H11.8699H11.8749H11.8799H11.8849H11.8898H11.8946H11.8994H11.9042H11.9089H11.9136H11.9182H11.9227H11.9272H11.9317H11.9361H11.9404H11.9447H11.949H11.9532H11.9573H11.9614H11.9655H11.9695H11.9734H11.9773H11.9812H11.9849H11.9887H11.9924H11.996H11.9996H12.0031H12.0066H12.01H12.0134H12.0167H12.0199H12.0231H12.0263H12.0294H12.0324H12.0354H12.0384H12.0412H12.0441H12.0468H12.0495H12.0522H12.0548H12.0574H12.0599H12.0623H12.0647H12.067H12.0693H12.0715H12.0737H12.0758H12.0778H12.0798H12.0817H12.0836H12.0854H12.0872H12.0889H12.0905H12.0921H12.0936H12.0951H12.0965H12.0979H12.0992H12.1004H12.1016H12.1027H12.1037H12.1047H12.1057H12.1066H12.1074H12.1081H12.1088H12.1095H12.1101H12.1106H12.111H12.1114H12.1118H12.1121H12.1123H12.1124H12.1125L12.1126 2L12.1126 2.5H12.1126H12.1126H12.1127H12.1128H12.1129H12.113H12.1131H12.1133H12.1135H12.1136H12.1139H12.1141H12.1143H12.1146H12.1149H12.1151H12.1155H12.1158H12.1161H12.1165H12.1169H12.1173H12.1177H12.1181H12.1185H12.119H12.1195H12.12H12.1205H12.121H12.1216H12.1221H12.1227H12.1233H12.1239H12.1245H12.1251H12.1258H12.1265H12.1271H12.1278H12.1286H12.1293H12.13H12.1308H12.1316H12.1324H12.1332H12.134H12.1348H12.1357H12.1365H12.1374H12.1383H12.1392H12.1401H12.141H12.142H12.143H12.1439H12.1449H12.1459H12.147H12.148H12.149H12.1501H12.1512H12.1522H12.1533H12.1545H12.1556H12.1567H12.1579H12.159H12.1602H12.1614H12.1626H12.1638H12.1651H12.1663H12.1675H12.1688H12.1701H12.1714H12.1727H12.174H12.1753H12.1767H12.178H12.1794H12.1807H12.1821H12.1835H12.1849H12.1864H12.1878H12.1892H12.1907H12.1921H12.1936H12.1951H12.1966H12.1981H12.1996H12.2012H12.2027H12.2042H12.2058H12.2074H12.209H12.2106H12.2122H12.2138H12.2154H12.217H12.2187H12.2203H12.222H12.2236H12.2253H12.227H12.2287H12.2304H12.2321H12.2339H12.2356H12.2374H12.2391H12.2409H12.2426H12.2444H12.2462H12.248H12.2498H12.2516H12.2535H12.2553H12.2571H12.259H12.2608H12.2627H12.2646H12.2665H12.2683H12.2702H12.2722H12.2741H12.276H12.2779H12.2798H12.2818H12.2837H12.2857H12.2877H12.2896H12.2916H12.2936H12.2956H12.2976H12.2996H12.3016H12.3036H12.3056H12.3077H12.3097H12.3117H12.3138H12.3158H12.3179H12.32H12.322H12.3241H12.3262H12.3283H12.3304H12.3325H12.3346H12.3367H12.3388H12.3409H12.3431H12.3452H12.3473H12.3495H12.3516H12.3538H12.3559H12.3581H12.3602H12.3624H12.3646H12.3668H12.369H12.3711H12.3733H12.3755H12.3777H12.3799H12.3821H12.3843H12.3866H12.3888H12.391H12.3932H12.3954H12.3977H12.3999H12.4021H12.4044H12.4066H12.4089H12.4111H12.4134H12.4156H12.4179H12.4201H12.4224H12.4247H12.4269H12.4292H12.4315H12.4338H12.436H12.4383H12.4406H12.4429H12.4452H12.4474H12.4497H12.452H12.4543H12.4566H12.4589H12.4612H12.4635H12.4658H12.4681H12.4704H12.4727H12.475H12.4773H12.4796H12.4819H12.4842H12.4865H12.4888H12.4911H12.4934H12.4957H12.498H12.5003H12.5026H12.5049H12.5072H12.5095H12.5118H12.5141H12.5164H12.5187H12.521H12.5233H12.5256H12.5279H12.5302H12.5325H12.5348H12.5371H12.5393H12.5416H12.5439H12.5462H12.5485H12.5508H12.5531H12.5553H12.5576H12.5599H12.5622H12.5645H12.5667H12.569H12.5713H12.5735H12.5758H12.578H12.5803H12.5826H12.5848H12.5871H12.5893H12.5915H12.5938H12.596H12.5983H12.6005H12.6027H12.6049H12.6072H12.6094H12.6116H12.6138H12.616H12.6182H12.6204H12.6226H12.6248H12.627H12.6291H12.6313H12.6335H12.6357H12.6378H12.64H12.6421H12.6443H12.6464H12.6486H12.6507H12.6528H12.655H12.6571H12.6592H12.6613H12.6634H12.6655H12.6676H12.6697H12.6718H12.6739H12.6759H12.678H12.6801H12.6821H12.6842H12.6862H12.6882H12.6903H12.6923H12.6943H12.6963H12.6983H12.7003H12.7023H12.7043H12.7063H12.7082H12.7102H12.7121H12.7141H12.716H12.718H12.7199H12.7218H12.7237H12.7256H12.7275H12.7294H12.7313H12.7332H12.735H12.7369H12.7387H12.7406H12.7424H12.7442H12.746H12.7478H12.7496H12.7514H12.7532H12.755H12.7567H12.7585H12.7602H12.762H12.7637H12.7654H12.7671H12.7688H12.7705H12.7722H12.7739H12.7755H12.7772H12.7788H12.7804H12.7821H12.7837H12.7853H12.7869H12.7884H12.79H12.7916H12.7931H12.7947H12.7962H12.7977H12.7992H12.8007H12.8022H12.8037H12.8051H12.8066H12.808H12.8094H12.8109H12.8123H12.8137H12.815H12.8164H12.8178H12.8191H12.8205H12.8218H12.8231H12.8244H12.8257H12.827H12.8282H12.8295H12.8307H12.8319H12.8331H12.8343H12.8355H12.8367H12.8379H12.839H12.8402H12.8413H12.8424H12.8435H12.8446H12.8456H12.8467H12.8477H12.8488H12.8498H12.8508H12.8518H12.8527H12.8537H12.8547H12.8556H12.8565H12.8574H12.8583H12.8592H12.86H12.8609H12.8617H12.8625H12.8633H12.8641H12.8649H12.8656H12.8664H12.8671H12.8678H12.8685H12.8692H12.8699H12.8705H12.8712H12.8718H12.8724H12.873H12.8735H12.8741H12.8746H12.8751H12.8757H12.8761H12.8766H12.8771H12.8775H12.8779H12.8784H12.8787H12.8791H12.8795H12.8798H12.8801H12.8804H12.8807H12.881H12.8813H12.8815H12.8817H12.8819H12.882H12.8821H12.8821H12.8822H12.8822H12.8823H12.8823H12.8824H12.8824H12.8825H12.8826H12.8826H12.8827H12.8827H12.8828H12.8828H12.8828H12.8829H12.8829H12.8829H12.8829H12.883H12.883H12.8831H12.8835H12.884H12.8845H12.8851H12.8857H12.8864H12.8872H12.888H12.8889H12.8898H12.8908H12.8919H12.893H12.8942H12.8954H12.8967H12.898H12.8994H12.9009H12.9024H12.904H12.9057H12.9074H12.9091H12.9109H12.9128H12.9147H12.9167H12.9188H12.9209H12.923H12.9252H12.9275H12.9298H12.9322H12.9346H12.9371H12.9397H12.9423H12.9449H12.9476H12.9504H12.9532H12.9561H12.959H12.962H12.965H12.9681H12.9713H12.9745H12.9777H12.981H12.9844H12.9878H12.9913H12.9948H12.9984H13.002H13.0057H13.0094H13.0132H13.017H13.0209H13.0248H13.0288H13.0329H13.037H13.0411H13.0453H13.0495H13.0538H13.0582H13.0626H13.067H13.0715H13.0761H13.0807H13.0853H13.09H13.0947H13.0995H13.1044H13.1093H13.1142H13.1192H13.1243H13.1293H13.1345H13.1397H13.1449H13.1502H13.1555H13.1609H13.1663H13.1718H13.1773H13.1828H13.1885H13.1941H13.1998H13.2056H13.2114H13.2172H13.2231H13.229H13.235H13.241H13.2471H13.2532H13.2594H13.2656H13.2718H13.2781H13.2845H13.2909H13.2973H13.3038H13.3103H13.3168H13.3234H13.3301H13.3368H13.3435H13.3503H13.3571H13.364H13.3709H13.3778H13.3848H13.3919H13.3989H13.4061H13.4132H13.4204H13.4277H13.4349H13.4423H13.4496H13.457H13.4645H13.472H13.4795H13.4871H13.4947H13.5023H13.51H13.5178H13.5255H13.5333H13.5412H13.5491H13.557H13.565H13.573H13.581H13.5891H13.5972H13.6054H13.6136H13.6218H13.6301H13.6384H13.6467H13.6551H13.6635H13.672H13.6805H13.689H13.6976H13.7062H13.7149H13.7235H13.7322H13.741H13.7498H13.7586H13.7675H13.7764H13.7853H13.7942H13.8032H13.8123H13.8213H13.8304H13.8396H13.8487H13.858H13.8672H13.8765H13.8858H13.8951H13.9045H13.9139H13.9233H13.9328H13.9423H13.9518H13.9614H13.971H13.9806H13.9903H14H14.0097H14.0195H14.0293H14.0391H14.049H14.0589H14.0688H14.0787H14.0887H14.0987H14.1088H14.1188H14.1289H14.1391H14.1492H14.1594H14.1696H14.1799H14.1901H14.2005H14.2108H14.2211H14.2315H14.242H14.2524H14.2629H14.2734H14.2839H14.2945H14.3051H14.3157H14.3263H14.337H14.3477H14.3584H14.3692H14.38H14.3908H14.4016H14.4124H14.4233H14.4342H14.4452H14.4561H14.4671H14.4781H14.4892H14.5002H14.5113H14.5224H14.5336H14.5447H14.5559H14.5671H14.5783H14.5896H14.6009H14.6122H14.6235H14.6349H14.6462H14.6576H14.669H14.6805H14.6919H14.7034H14.7149H14.7265H14.738H14.7496H14.7612H14.7728H14.7845H14.7961H14.8078H14.8195H14.8312H14.843H14.8547H14.8665H14.8783H14.8901H14.902H14.9139H14.9257H14.9376H14.9496H14.9615H14.9735H14.9855H14.9975H15.0095H15.0215H15.0336H15.0456H15.0577H15.0698H15.082H15.0941H15.1063H15.1185H15.1307H15.1429H15.1551H15.1674H15.1796H15.1919H15.2042H15.2165H15.2288H15.2412H15.2536H15.2659H15.2783H15.2907H15.3032H15.3156H15.3281H15.3405H15.353H15.3655H15.378H15.3906H15.4031H15.4156H15.4282H15.4408H15.4534H15.466H15.4786H15.4913H15.5039H15.5166H15.5292H15.5419H15.5546H15.5673H15.5801H15.5928H15.6056H15.6183H15.6311H15.6439H15.6567H15.6695H15.6823H15.6951H15.7079H15.7208H15.7336H15.7465H15.7594H15.7723H15.7852H15.7981H15.811H15.8239H15.8369H15.8498H15.8628H15.8757H15.8887H15.9017H15.9146H15.9276H15.9406H15.9537H15.9667H15.9797H15.9927H16.0058H16.0188H16.0319H16.0449H16.058H16.0711H16.0842H16.0973H16.1104H16.1235H16.1366H16.1497H16.1628H16.1759H16.1891H16.2022H16.2153H16.2285H16.2416H16.2548H16.2679H16.2811H16.2943H16.3074H16.3206H16.3338H16.347H16.3602H16.3733H16.3865H16.3997H16.4129H16.4261H16.4393H16.4525H16.4657H16.479H16.4922H16.5054H16.5186H16.5318H16.545H16.5583H16.5715H16.5847H16.5979H16.6111H16.6244H16.6376H16.6508H16.664H16.6773H16.6905H16.7037H16.7169H16.7302H16.7434H16.7566H16.7698H16.7831H16.7963H16.8095H16.8227H16.8359H16.8491H16.8624H16.8756H16.8888H16.902H16.9152H16.9284H16.9416H16.9548H16.9679H16.9811H16.9943H17.0075H17.0207H17.0338H17.047H17.0602H17.0733H17.0865H17.0996H17.1128H17.1259H17.1391H17.1522H17.1653H17.1784H17.1916H17.2047H17.2178H17.2309H17.2439H17.257H17.2701H17.2832H17.2962H17.3093H17.3224H17.3354H17.3484H17.3615H17.3745H17.3875H17.4005H17.4135H17.4265H17.4395H17.4524H17.4654H17.4784H17.4913H17.5042H17.5172H17.5301H17.543H17.5559H17.5688H17.5817H17.5945H17.6074H17.6202H17.6331H17.6459H17.6587H17.6715H17.6843H17.6971H17.7099H17.7226H17.7354H17.7481C18.6521 2.5 19.3024 2.94304 19.7445 3.41685C19.9656 3.65381 20.1281 3.8923 20.235 4.07142C20.2881 4.16052 20.3267 4.23362 20.3513 4.28272C20.3628 4.30568 20.3712 4.32329 20.3765 4.3347L22.3845 10.2632L22.4375 10.4198L22.5734 10.5139C23.2002 10.948 23.5602 11.5561 23.7644 12.0754C23.8659 12.3334 23.9262 12.5629 23.9609 12.7261C23.9781 12.8074 23.9889 12.8715 23.9951 12.9135C23.9972 12.9278 23.9988 12.9395 24 12.9484V20.1224C24 20.9002 23.3966 21.5 22.6793 21.5C21.9629 21.5 21.3585 20.8956 21.3585 20.1224V18.8427V18.3181L20.8346 18.3433L20.8585 18.8427L20.8345 18.3433L20.8343 18.3433L20.8336 18.3433L20.8304 18.3435L20.8179 18.3441L20.769 18.3464L20.5812 18.3552C20.4186 18.3629 20.1841 18.3738 19.8971 18.3869C19.3229 18.413 18.5384 18.4479 17.6969 18.4828C16.2772 18.5417 14.7063 18.6001 13.7072 18.6171V18.6165H13.2072H12.0855C11.1818 18.6165 9.20697 18.5472 7.44648 18.4772C6.56876 18.4423 5.74813 18.4074 5.14689 18.3812C4.84629 18.3681 4.60057 18.3572 4.43003 18.3496L4.23315 18.3408L4.18177 18.3384L4.16867 18.3378L4.16537 18.3377L4.16455 18.3376L4.16435 18.3376L4.14145 18.8371Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M5 15C5.82843 15 6.5 14.3284 6.5 13.5C6.5 12.6716 5.82843 12 5 12C4.17157 12 3.5 12.6716 3.5 13.5C3.5 14.3284 4.17157 15 5 15Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4971 14H9.4971C8.94638 14 8.5 13.5523 8.5 13C8.5 12.4477 8.94638 12 9.4971 12H15.5029C16.0536 12 16.5 12.4477 16.5 13C16.4942 13.5523 16.0478 14 15.4971 14Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M20 15C20.8284 15 21.5 14.3284 21.5 13.5C21.5 12.6716 20.8284 12 20 12C19.1716 12 18.5 12.6716 18.5 13.5C18.5 14.3284 19.1716 15 20 15Z"
        stroke="white"
        strokeMiterlimit="10"
      />
      <path
        d="M13.3935 8.83986L13.1024 8.84589H11.6C9.63839 8.80248 8.2677 8.98275 7.26986 9.16848C6.9644 9.22534 6.67887 9.28595 6.43424 9.33788C6.29403 9.36764 6.16727 9.39455 6.05788 9.41626C5.73071 9.48122 5.52292 9.50769 5.36654 9.49816L5.3665 9.49815C5.24919 9.49102 5.18664 9.46002 5.15125 9.43505C5.11412 9.40885 5.08107 9.3707 5.05121 9.31534C4.99313 9.19414 4.98218 9.03302 5.03002 8.89028L5.03103 8.88721L6.16538 5.42774L6.16538 5.42774L6.16598 5.4259C6.26526 5.11912 6.44286 4.8628 6.66569 4.69047L6.66571 4.69049L6.66952 4.68747C6.81968 4.569 6.97928 4.5 7.15109 4.5H11.5944H13.4039H17.8472C18.0089 4.5 18.175 4.57118 18.3343 4.69176C18.5563 4.86408 18.7333 5.11989 18.8323 5.42591L18.833 5.42799L19.9673 8.88132L19.9673 8.88132L19.9683 8.88413C20.0191 9.03594 20.0063 9.19498 19.9486 9.30647L19.9485 9.30645L19.9454 9.31267C19.9201 9.36326 19.8887 9.40115 19.8502 9.42811C19.8141 9.45347 19.7498 9.48483 19.6318 9.49201L19.6317 9.49201C19.4749 9.50157 19.2667 9.4753 18.9397 9.41085C18.8296 9.38915 18.7015 9.36214 18.5597 9.33223C18.3158 9.28079 18.0313 9.22078 17.728 9.16457C16.7296 8.97953 15.3577 8.79912 13.3935 8.83986Z"
        stroke="white"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_2786_5232">
        <rect width={24} height={24} fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export const CircleArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={16} cy={16} r={15.25} stroke={color} strokeWidth="1.5" />
    <path
      d="M22.9332 16.0002H8.5332M8.5332 16.0002L13.3332 11.2002M8.5332 16.0002L13.3332 20.8002"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleX = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    viewBox="0 0 30 30"
    {...props}
  >
    <circle cx={15} cy={15} r={14.5} fill="none" stroke={color} />
    <path
      d="M15 14.5l7.2-7.2c.1-.1.4-.1.5 0 .1.1.1.4 0 .5L15.5 15l7.2 7.2c.1.1.1.4 0 .5-.1.1-.4.1-.5 0L15 15.5l-7.2 7.2c-.1.1-.4.1-.5 0-.1-.1-.1-.4 0-.5l7.2-7.2-7.2-7.2c-.1-.1-.1-.4 0-.5.1-.1.4-.1.5 0l7.2 7.2z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={color}
    />
  </svg>
);

export const CircleCloseBanner = ({
  color = 'currentColor',
  fill = '#ffffff',
  strokeWidth = '1.5',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="82"
    height="30"
    viewBox="0 0 82 30"
    fill={fill}
  >
    <circle cx="65.9377" cy="15" r="14" stroke="white" strokeWidth="2" />
    <path
      d="M70.9377 10L65.9377 15L70.9377 20"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M60.9377 20L65.9377 15L60.9377 10"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.39774 11.84V15.66C3.39774 16.58 3.55774 17.16 3.97774 17.56C4.31774 17.88 4.79774 18.06 5.49774 18.06C6.85774 18.06 7.45774 17.38 7.45774 15.76V15.38H9.61774V15.74C9.61774 18.52 8.19774 20.12 5.47774 20.12C2.75774 20.12 1.23774 18.68 1.23774 15.82V11.7C1.23774 8.84 2.75774 7.4 5.47774 7.4C8.19774 7.4 9.61774 8.9 9.61774 11.72V12.14H7.45774V11.76C7.45774 10.22 6.89774 9.46 5.49774 9.46C4.75774 9.46 4.23774 9.66 3.89774 10.02C3.53774 10.4 3.39774 10.94 3.39774 11.84ZM11.2201 6.64H13.2601V20H11.2201V6.64ZM14.8593 16.58V13.7C14.8593 11.34 16.1793 10.14 18.5193 10.14C20.8593 10.14 22.1793 11.34 22.1793 13.7V16.58C22.1793 18.92 20.8593 20.12 18.5193 20.12C16.1793 20.12 14.8593 18.92 14.8593 16.58ZM16.8993 13.98V16.28C16.8993 17.08 16.9793 17.5 17.2193 17.8C17.4793 18.12 17.9193 18.26 18.5193 18.26C19.1193 18.26 19.5593 18.12 19.8193 17.8C20.0593 17.5 20.1393 17.08 20.1393 16.28V13.98C20.1393 13.2 20.0593 12.76 19.8193 12.46C19.5593 12.14 19.1193 12 18.5193 12C17.9193 12 17.4793 12.14 17.2193 12.46C16.9793 12.76 16.8993 13.2 16.8993 13.98ZM23.3288 16.82H25.2688V17.06C25.2688 17.92 25.7088 18.38 26.6688 18.38C27.5488 18.38 27.9488 17.86 27.9488 17.26C27.9488 15.6 23.3088 16.4 23.3088 13C23.3088 11.16 24.7488 10.14 26.5088 10.14C28.5288 10.14 29.6888 11.24 29.6888 13.2V13.42H27.7488V13.26C27.7488 12.4 27.3488 11.9 26.5288 11.9C25.7688 11.9 25.3488 12.3 25.3488 12.9C25.3488 14.58 29.9888 13.98 29.9888 17.14C29.9888 18.72 28.9288 20.12 26.6688 20.12C24.6488 20.12 23.3288 19.06 23.3288 17.18V16.82ZM30.9437 16.58V13.7C30.9437 11.34 32.2037 10.14 34.5437 10.14C36.8837 10.14 38.1437 11.34 38.1437 13.7V15.34C38.1437 15.76 37.8837 15.88 37.5837 15.88H32.9837V16.34C32.9837 17.5 33.1437 18.3 34.5437 18.3C35.6237 18.3 36.0837 17.78 36.0837 16.82H38.1037V16.86C38.1037 19 36.7637 20.12 34.5437 20.12C32.2037 20.12 30.9437 18.92 30.9437 16.58ZM32.9837 13.94V14.26H36.1037V13.94C36.1037 12.76 35.9237 11.96 34.5437 11.96C33.2637 11.96 32.9837 12.64 32.9837 13.94Z"
      fill="white"
    />
  </svg>
);

export const CircleCloseMobile = ({
  color = 'currentColor',
  fill = '#ffffff',
  strokeWidth = '1.5',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="27"
    viewBox="0 0 28 27"
    fill={fill}
  >
    <path
      d="M25.7207 13.5645C25.7207 20.2276 20.3192 25.629 13.6562 25.629C6.99314 25.629 1.59167 20.2276 1.59167 13.5645C1.59167 6.90147 6.99314 1.5 13.6562 1.5C20.3192 1.5 25.7207 6.90147 25.7207 13.5645Z"
      stroke="white"
      strokeWidth="2"
    />
    <g clipPath="url(#clip0_1_844)">
      <path
        d="M18.6562 8.5L13.6562 13.5L18.6562 18.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.65625 18.5L13.6563 13.5L8.65625 8.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_844">
        <rect
          width="13"
          height="12"
          fill="white"
          transform="translate(7.15625 7.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const CircleCloseTransparent = ({
  color = 'currentColor',
  fillColor = '#ffffff',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <circle
      cx="20"
      cy="20"
      r="19"
      fill="white"
      fillOpacity="0.1"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M26.25 13.75L20 20L26.25 26.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.75 26.25L20 20L13.75 13.75"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CircleClose = ({
  color = 'currentColor',
  fillColor = '#ffffff',
  ...props
}) => (
  <svg
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={20}
      cy={20}
      r="19.25"
      fill={fillColor}
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M25 15L20 20L25 25"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 25L20 20L15 15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClearLocationSearchIcon = ({
  color = 'currentColor',
  fillColor = '#ffffff',
  ...props
}) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 0.75L0.75 12.75M0.75 0.75L12.75 12.75"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Magnifier = ({ color = 'currentColor', ...props }) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5 11h-.8l-.3-.3c1-1.1 1.6-2.6 1.6-4.2C13 2.9 10.1 0 6.5 0S0 2.9 0 6.5 2.9 13 6.5 13c1.6 0 3.1-.6 4.2-1.6l.3.3v.8l5 5 1.5-1.5-5-5zm-6 0C4 11 2 9 2 6.5S4 2 6.5 2 11 4 11 6.5 9 11 6.5 11z"
      fill={color}
    />
  </svg>
);

export const LocationMagnifier = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width="24" height="24" fill="white" />
    <path
      d="M10.5345 16.4699C11.9956 16.4709 13.4148 16.0023 14.5628 15.1382L18.893 19.2727L20 18.2157L15.6698 14.0812C16.8932 12.5897 17.3411 10.648 16.885 8.80391C16.4299 6.95974 15.1209 5.41359 13.3282 4.60105C11.5355 3.78954 9.45306 3.80026 7.66959 4.63028C5.88611 5.4603 4.59447 7.01904 4.15879 8.86806C3.72413 10.7161 4.19246 12.6529 5.43316 14.1316C6.67285 15.6105 8.55033 16.4707 10.5347 16.4697L10.5345 16.4699ZM10.5345 5.49642C11.8508 5.49642 13.1129 5.99521 14.0435 6.88467C14.9751 7.77315 15.4975 8.97824 15.4975 10.2351C15.4975 11.4919 14.9751 12.6969 14.0435 13.5855C13.113 14.475 11.8509 14.9738 10.5345 14.9738C9.21822 14.9738 7.9562 14.475 7.02557 13.5855C6.09403 12.697 5.57162 11.4919 5.57162 10.2351C5.57162 8.97824 6.09403 7.77325 7.02557 6.88467C7.9561 5.99521 9.21822 5.49642 10.5345 5.49642Z"
      fill="#5B6885"
    />
  </svg>
);
export const LocationMagnifierTransparent = ({
  color = 'currentColor',
  ...props
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5345 16.4699C11.9956 16.4709 13.4148 16.0023 14.5628 15.1382L18.893 19.2727L20 18.2157L15.6698 14.0812C16.8932 12.5896 17.3411 10.6479 16.885 8.8039C16.4299 6.95972 15.1209 5.41358 13.3282 4.60104C11.5355 3.78952 9.45306 3.80025 7.66959 4.63027C5.88611 5.46029 4.59447 7.01903 4.15879 8.86804C3.72413 10.7161 4.19246 12.6529 5.43316 14.1316C6.67285 15.6104 8.55033 16.4707 10.5347 16.4697L10.5345 16.4699ZM10.5345 5.4964C11.8508 5.4964 13.1129 5.9952 14.0435 6.88465C14.9751 7.77313 15.4975 8.97823 15.4975 10.2351C15.4975 11.4919 14.9751 12.6969 14.0435 13.5855C13.113 14.4749 11.8509 14.9737 10.5345 14.9737C9.21822 14.9737 7.9562 14.4749 7.02557 13.5855C6.09403 12.697 5.57162 11.4919 5.57162 10.2351C5.57162 8.97823 6.09403 7.77323 7.02557 6.88465C7.9561 5.9952 9.21822 5.4964 10.5345 5.4964Z"
      fill="currentColor"
    />
  </svg>
);

export const CircleTick = ({
  color = 'currentColor',
  width = '24',
  height = '25',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <circle cx={12} cy={12.5} r={11.25} stroke={color} strokeWidth="1.5" />
      <path
        d="M17.5998 8.4998L10.3998 16.4998L6.7998 13.2998"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width={24}
          height={24}
          fill="#ffffff"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const Compass = ({ color = 'currentColor', ...props }) => (
  <svg
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5 2l-12 5v.667L7.033 9.4l1.734 4.533h.666L14.5 2z"
      fill={color}
    />
  </svg>
);

export const Pin = ({ color = 'currentColor', ...props }) => (
  <svg
    width={9}
    height={12}
    viewBox="0 0 9 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.5 0c-2.229 0-4 1.86-4 4.2 0 3.12 4 7.8 4 7.8s4-4.68 4-7.8c0-2.34-1.771-4.2-4-4.2zm0 5.7c-.8 0-1.429-.66-1.429-1.5S3.7 2.7 4.5 2.7s1.429.66 1.429 1.5S5.3 5.7 4.5 5.7z"
      fill={color}
    />
  </svg>
);

export const Crest = ({ color = 'currentColor', ...props }) => (
  <svg
    width={35}
    height={42}
    viewBox="0 0 35 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.378 10.443h-.147c-1.158-.016-2.235-.408-3.377-.816a24.09 24.09 0 00-2.089-.685c-.228 1.126.8 2.104 2.399 2.088.554 0 .75-.163 1.223-.163.294 0 .506.212.506.473 0 .327-.228.571-.701.571-.196 0-.457-.049-.62-.146-.506 0-.67.293-.718.62a.46.46 0 00-.212.391v.326s.342-.212.701-.212h.62a.897.897 0 01-.62.327.765.765 0 00-.13.897.47.47 0 00.016.44l.163.278s.196-.359.522-.555c.163-.098.571-.326.571-.326-.13.343 0 .685.294.865a.43.43 0 00.229.342l.277.164s.016-.474.196-.784l.636-1.093h.734v-1.517c0-.457.278-.898.735-1.567a7.38 7.38 0 01-1.208.082z"
      fill={color}
    />
    <path
      d="M31.247 7.424c-.522 0-.881-.065-1.273-.375l-.375-.36 1.583-.015s2.741-.147 3.524-1.795a2.787 2.787 0 00.261-1.616 2.61 2.61 0 00-.718-1.468c-.375-.408-.979-.832-2.056-.849-2.692-.032-4.52 1.86-7.717 2.04-1.991.114-5.14.098-7.702.082a.335.335 0 01-.343-.376c.017-.163.147-.31.327-.31l7.375-.049c1.158 0 2.088-1.06 2.088-2.333a1.65 1.65 0 01-1.011.522c.032-.163.049-.343.049-.522-.44.408-1.322.538-1.68.538h-.735c-.588 0-1.126.278-1.501.702h-4.667c-.963 0-1.37.816-1.42 1.322-.081.75.343 1.648 1.485 1.713 2.203.016 7.392.016 8.42-.098 1.387-.147 2.3-.49 3.1-.734 1.077-.326 2.366-1.175 3.9-1.142 1.126.032 1.37.88 1.403 1.142.033.26-.016.538-.13.783-.555 1.126-3.117 1.273-5.744 1.077-4.422-.326-7.946-.718-12.368.016a8.908 8.908 0 00-1.664.457c.032.457-.017 1.126-.343 1.893l-.13.326-.327-.147-.098-.049c-.212.327-.44.604-.685.833l-.18.163-.212-.114a.686.686 0 00-.342-.098c-.262 0-.506.18-.62.44-.506 1.224-.93 1.257-2.073 1.354-.065 0-.342.033-.342.033s-.474-.31-.555-.359c-1.403-.049-3.198-.342-3.965-.587-.408-.13-.702-.555-.702-1.012 0-.065 0-.114.016-.18a.714.714 0 00-.766-.44.495.495 0 00-.49-.13l-.31.097s.375.343.473.637l.147.44a1.138 1.138 0 01-.522-.44.797.797 0 00-.93.163.47.47 0 00-.49.147l-.195.277s.408.05.734.31l.473.392a.78.78 0 00-.718.604.434.434 0 00-.343.358l-.065.327s.702-.147 1.077-.065l1.142.342h1.616a.87.87 0 01.864.865c.62.261 1.795.718 3.166 1.925.294-.244.538-.505.767-.8.359.082.734.148.979.164.995-.571 2.447-1.99 3.655-2.953.783-.62 1.893-1.37 3.328-1.828.164.376.441.67.686.849.8-.555 2.366-1.452 4.47-.947 2.056.522 3.623 1.502 5.532 1.518.995 0 1.942-.147 2.823-.44.391-.115.555-.18 1.06-.18a.87.87 0 01.865.865.87.87 0 01-.865.864.887.887 0 01-.783-.473c-.391-.212-.75-.114-.963.114a.474.474 0 00-.456.261l-.147.294s.473 0 .685.114l.506.278a.925.925 0 01-.294.049c-.114 0-.245-.033-.343-.066-.391.066-.701.392-.701.8v.392a.487.487 0 00-.245.424v.342s.522-.277 1.06-.277h2.938l.669-1.468h.652v-.914c0-.653.506-1.175 1.159-1.24-.31-1.746-1.86-2.399-3.753-2.399z"
      fill={color}
    />
    <path
      d="M13.264 5.417c.457-.146.8-.359.914-.652.278-.702.294-1.338.082-2.121-.457-.262-.963-.31-1.273-.31-.163 0-.261.016-.261.016-.261-.816-1.305-1.485-1.99-1.762 0 0-.05.146-.213.326-.049-.016-.081-.016-.098-.016A3.19 3.19 0 009.658.8c-.587 0-1.093.18-1.517.424-.016-.016-.67-.457-1.42-.457h-.065c-.555.588-.832 1.159-.93 1.91-.033.31.163.668.506 1.01l.032.017c-.195.653-.456 1.142-.848 1.713.13.115.294.196.473.261 0 .441.065.898.212 1.306.686 0 1.077.555 1.012 1.142-.114 1.175.114 1.24 1.24 1.974 1.305-.114 1.566-.081 2.007-1.174.163-.392.522-.653.93-.653.163 0 .326.049.506.13.31-.293.571-.636.783-1.011.13.049.261.098.392.163.359-.832.391-1.6.293-2.138zM7.57 3.345v-.098l.032.033.62.294a.44.44 0 00-.13.114.356.356 0 00.13.506c.066.032.131.049.196.049.13 0 .261-.066.327-.18.049-.081.049-.147.049-.228 0 0 .424.18.342.685-.049.392-.326.832-.326.832s-.196-.098-.065-.44c.147-.408.081-.425.081-.425s-.081.017-.196.017c-.163 0-.375-.017-.57-.13l-.033-.017c-.473-.327-.457-.947-.457-1.012zm2.464 4.112c-.604.277-.278 1.028-.506 1.403-.13.212-.294.31-.539.31a1.83 1.83 0 01-.391-.049c-.473-.114-.686-.293-.702-.669-.016-.424.62-.93.229-1.468-.343-.457-.294-.702-.294-.702s.114.114.359.245c.033.016.196.098.359.147.065.016.13.032.212.032.163 0 .326-.065.408-.293.049-.13-.05-.229-.147-.294-.049-.033-.228-.147-.277-.196-.098-.13 0-.31 0-.31s.228.31.652.408a.856.856 0 00.278.033c.26 0 .44-.098.44-.098s.017.196-.147.261c-.065.033-.228.033-.293.049-.115.016-.245.049-.278.196-.065.326.18.457.408.506.147.032.294.048.36.048h.032c.277-.016.424-.048.424-.048s-.065.244-.587.489zm2.235-3.002l-.016.032c-.033.066-.327.62-.914.653h-.049c-.359 0-.701-.261-.701-.261-.017 0-.066.016-.131.408-.049.343-.261.343-.277.343 0 0-.033-.523.114-.882a.652.652 0 01.604-.424h.032a.293.293 0 00-.065.229c0 .212.18.359.375.359h.017a.38.38 0 00.375-.376.276.276 0 00-.05-.163l.686.033h.049l-.049.049zM7.605 31.476c1.485.032 2.741.799 3.312 2.072.914.522 2.497 1.452 5.222 2.35 1.745.065 4.128.048 7.228-.18-.163-.457-.18-.995-.017-1.73.066-.293.017-.57-.146-.783-.147-.212-.376-.326-.653-.359l-.294-.032-.114-.278a4.597 4.597 0 01-.31-1.583c-.767-.032-3.671-.18-5.972-1.077-.294.36-.555.572-.636.62-2.203-.522-4.39-1.24-5.956-2.12a1.847 1.847 0 01-.587.097 2.027 2.027 0 01-2.024-1.86 3.335 3.335 0 010-.571 1.254 1.254 0 00-1.354-.783.78.78 0 00-.865-.212l-.538.18s.669.62.848 1.125l.278.767a1.909 1.909 0 01-.914-.767c-.539-.261-1.126-.245-1.566.212a.788.788 0 00-.849.245l-.375.44s.718.082 1.289.555c.016 0 .832.702.832.702a1.404 1.404 0 00-1.29 1.077.825.825 0 00-.62.636l-.113.555s1.631-.212 2.268-.082l2.251.816c-.016-.032.914-.032 1.665-.032zM27.101 32.503c-.245.196-.604.245-1.028.147-.065-.016-.114-.033-.163-.049.408.636.114 1.257-.114 1.713-.115.212-.212.425-.212.571.016.278.065.474.734.637.669.163.816.032.962-.212.082-.114.082-.36.098-.604.017-.506.05-1.191.735-1.55-.05-.017-.115-.017-.18-.033-.424-.114-.701-.326-.832-.62z"
      fill={color}
    />
    <path
      d="M33.955 29.436c.326-.816.343-1.567.098-2.464-.75-.44-1.713-.36-1.811-.36-.588-.913-1.37-1.68-2.758-2.039-.032 0-.636-.163-.669-.163-1.403-.343-2.447-.033-3.394.506-.098-.066-.897-.571-1.762-.539-.653.67-.979 1.338-1.077 2.22-.033.293.18.701.473 1.044-.995 1.011-1.24 1.892-1.305 2.66.294.016.587.08.587.08-.032.62-.016 1.257.262 1.959.913.114 1.403.914 1.223 1.746-.391 1.778.343 2.17 2.007 3.345 2.023-.261 2.856-.261 3.345-2.007.229-.816 1.044-1.306 1.893-.963 1.73-1.403 2.04-3.1 2.105-3.508a1.19 1.19 0 01-.408-.702c.538-.18 1.06-.473 1.191-.816zm-8.305-.294c-.67-.408-.637-1.24-.637-1.338v-.131l.05.033.815.392c-.065.049-.13.097-.163.163a.493.493 0 00.18.685.487.487 0 00.685-.18c.065-.097.065-.212.065-.31 0 0 .555.245.457.914-.082.522-.44 1.11-.44 1.11s-.262-.147-.098-.588c.195-.554.114-.554.114-.554s-.588.081-1.012-.164l-.016-.032zm2.692 4.291c-.881.408-.408 1.518-.75 2.056-.294.473-.686.555-1.371.375-.702-.18-.995-.424-1.028-.979-.033-.636.93-1.37.342-2.154-.505-.685-.44-1.028-.44-1.028s.18.164.522.36c.049.032.277.146.538.212.343.081.751.081.898-.376.065-.196-.082-.342-.212-.44-.065-.05-.18-.114-.245-.196-.147-.196 0-.44 0-.44s.18.358.783.505c.62.163.947-.081.947-.081s.016.293-.212.391c-.082.033-.213.033-.31.05-.164.032-.36.08-.408.277-.098.473.26.669.603.766.261.066.506.066.571.066.408-.017.637-.066.637-.066s-.082.343-.865.702zm2.904-4.128l-.032.049c-.05.098-.44.832-1.224.865h-.049c-.49.016-.963-.343-.963-.343s-.081-.033-.18.538c-.064.457-.374.457-.374.457s-.033-.685.163-1.174c.244-.62.848-.572.848-.572a.456.456 0 00-.098.294c0 .278.229.49.506.49a.485.485 0 00.49-.506c0-.082-.033-.147-.066-.212l.914.049h.065v.065zM9.185 6.82c-.163.131-.408.164-.701.099-.033-.017-.082-.017-.114-.033.277.44.081.849-.082 1.159-.065.146-.147.293-.147.391.016.18.05.31.506.424.457.115.555.017.653-.146.049-.082.049-.245.065-.408.016-.343.033-.8.49-1.061-.033 0-.082-.016-.115-.016-.277-.066-.473-.212-.555-.408zM27.935 21.914c1.828-.196 4.014.603 5.336 2.186.359.114.88.277 1.468.457.033-.457.05-.897.05-1.37v-3.02c-2.677.033-5.027.637-6.854 1.747zM17.182 18.617c-.229.18-.555.229-.93.114l-.147-.049c.375.588.081 1.159-.13 1.567-.099.196-.197.392-.197.522 0 .245.05.424.653.587.604.164.734.033.865-.18.065-.113.081-.342.098-.554.032-.457.065-1.093.669-1.42-.05-.016-.098-.016-.147-.032-.375-.082-.62-.277-.734-.555z"
      fill={color}
    />
    <path
      d="M22.42 15.86l.081-.082c.62-.701.767-1.664.816-2.12a2.705 2.705 0 01-.62-.017l-.163-.033-.016-.163c0-.016-.163-1.093-.93-1.925-.261.391-.75.636-1.37.457a1.21 1.21 0 01-.8-1.453.72.72 0 01.098-.26c-1.257.016-2.056.717-2.073.734l-.098.098-.13-.05c-.033-.016-.767-.293-1.093-.88-.294.244-.784.75-.996 1.435l-.049.164h-.18c-.472-.017-.733.098-1.24.342.409.914.18 1.811-.195 2.35-.31.457-.718.734-1.142.783.228.67.636 1.012.652 1.012l.147.114-.098.163a3.92 3.92 0 00-.473 2.187c.571-.147.947-.131.947-.131s-.408 1.044.228 2.023c.033.05.065.114.098.18.392.75.392 1.582.326 2.333.392 0 .75-.326.75-.326l.05.359c.098.701.326 1.126.848 1.582.13-.456.457-1.158 1.159-1.19.375-.017.669.195.832.342 1.06-.685 1.517-1.68 1.827-2.643l.082-.245s.506.163.8.375c1.011-1.044 1.093-3.23 1.093-3.23s.49.13.848.31c.229-.833.229-1.518.017-2.53l-.033-.065zm-6.902-1.37v-.098l.049.032.685.343a.497.497 0 00-.13.13.43.43 0 00.146.588.422.422 0 00.572-.147c.049-.082.065-.18.049-.261 0 0 .456.212.375.783-.065.44-.375.947-.375.947s-.213-.115-.066-.49c.163-.457.098-.473.098-.473s-.49.065-.848-.147l-.033-.016c-.555-.408-.522-1.11-.522-1.191zm2.774 5.009c-.8.375-.392 1.387-.702 1.876-.26.424-.62.506-1.24.326-.62-.163-.897-.407-.914-.913-.016-.588.849-1.257.343-1.974-.44-.62-.375-.947-.375-.947s.163.147.473.343c.049.032.245.147.473.195.31.082.67.082.816-.342.065-.18-.065-.31-.18-.408-.065-.049-.163-.114-.212-.18-.13-.179 0-.407 0-.407s.147.326.702.473c.555.147.848-.066.848-.066s.017.261-.195.36c-.082.032-.196.032-.278.048-.147.017-.326.066-.359.262-.081.424.229.62.539.701.228.065.457.065.522.065.359-.016.57-.065.57-.065s-.13.326-.831.653zm2.431-3.688l-.016.05c-.033.08-.376.7-1.028.717h-.05c-.407 0-.799-.31-.799-.31s-.065-.033-.147.457c-.065.391-.31.391-.31.391s-.016-.587.147-.995c.212-.522.718-.473.718-.473a.44.44 0 00-.081.245c0 .228.195.424.424.424a.421.421 0 00.424-.424.329.329 0 00-.049-.18l.75.05h.05l-.033.048z"
      fill={color}
    />
    <path
      d="M34.771 19.694v-4.52c-3.492-.163-8.207.392-11.78 1.29.228 1.533-.294 2.675-.294 2.675l-.473-.228a.877.877 0 00-.229-.098c-.196 2.121-1.452 3.215-1.452 3.215s-.261-.229-.604-.36c-.326.93-.832 1.926-1.942 2.644l-.293.196-.261-.229c-.098-.081-.278-.228-.522-.228-.441 0-.637.473-.751.865l-.163.62s-.147-.082-.571-.408c-.425-.327-.8-.914-.947-1.567-.457.13-.913.082-.913.082s.163-1.012.081-1.68c-2.252-.082-5.417-.507-7.342-1.274-.653.408-1.404-.049-1.567-.163a1.442 1.442 0 01-.457-1.044c0-.081.017-.163.017-.245a1.022 1.022 0 00-1.094-.636.64.64 0 00-.685-.18l-.44.147s.538.49.669.898l.212.62a1.605 1.605 0 01-.735-.62c-.44-.212-.913-.196-1.256.18a.64.64 0 00-.685.195L0 20.184s.571.065 1.028.44c.016 0 .669.555.669.555-.49.033-.914.375-1.028.865a.672.672 0 00-.49.506l-.081.456s1.305-.179 1.827-.065l1.746.653h1.942c.963 0 1.779.604 1.942 1.55 0 0 1.925.114 3.736.946.947.457 2.04 1.175 3.117 2.268.359-.277.734-.767 1.011-1.142 1.306.327 1.91.457 2.546.539.979-.653 2.35-2.252 3.492-3.313a13.638 13.638 0 011.713-1.354c.359-.065 1.158-.098 2.17.359.294-.326.914-.93.914-.93 2.04-1.746 5.025-2.758 8.517-2.823zM6.968 9.382c-.212-.342-.228-.767-.18-1.321a.802.802 0 00-.162-.555.688.688 0 00-.506-.212h-.245l-.082-.229c-.13-.359-.195-.767-.228-1.19-.506-.262-.702-.441-1.044-.637.032-.196.032-.392.032-.588-.065.017-.13.017-.212.017a1.11 1.11 0 01-1.11-1.11c0-.326.131-.603.343-.816.147-.587-.244-.815-.244-.815.016-.196-.082-.343-.245-.474 0 0-.18-.146-.294-.195 0 0-.016.538-.18.832l-.244.44a.743.743 0 01-.082-.326c0-.13.033-.245.082-.343-.016-.457-.212-.636-.555-.62a.497.497 0 00-.44-.293h-.343s.261.456.261.8v.048C1.127 1.452.898 1.24.621 1.24H.278s.261.457.261.8v2.708a72.24 72.24 0 011.224.62c.245.13.392.392.392.686a.775.775 0 01-.098.391c.506.457 2.105 2.007 3.981 3.133.408.05.832.098 1.224.114a1.07 1.07 0 01-.294-.31z"
      fill={color}
    />
    <path
      d="M13.396 21.033c-.032-.05-.065-.114-.098-.164-.244-.44-.49-.897-.391-1.73-.082.017-.163.034-.261.05l-.522.13-.05-.538a4.2 4.2 0 01.213-1.762c-.506-.05-2.285-.278-3.737-1.175-.18.228-.228.326-.391.457-1.143-.294-2.073-.637-2.758-1.093a.836.836 0 01-1.469-.538.83.83 0 01.408-.719c.098-.669-.358-.93-.358-.93.032-.261-.115-.44-.327-.636 0 0-.245-.196-.391-.261 0 0-.033.718-.245 1.11-.212.39-.343.587-.343.587a.952.952 0 01-.098-.425c0-.163.05-.326.114-.457-.016-.603-.326-.848-.766-.832a.621.621 0 00-.588-.375H.881s.343.604.343 1.06c0 .05-.016.164-.033.294a.636.636 0 00-.554-.31H.18s.342.865.342 1.338v2.709l3.753 1.207c.555.18.963.702.963 1.322v.082c.636.359 1.73.8 3.606 1.485 1.224.26 2.855.505 4.748.57a4.768 4.768 0 00-.196-.456zM26.222 37.871c-.114.017-.522.066-.522.066s-.343-.245-.44-.31c-.719-.506-1.306-.914-1.665-1.453-2.187.164-4.03.229-5.58.229-2.84 0-4.667-.228-5.728-.424a2.004 2.004 0 01-.636.114 1.877 1.877 0 01-1.795-2.431c-.147-.539-.702-.93-1.256-.881a.832.832 0 00-.816-.294l-.539.13s.588.67.718 1.175l.098.375a1.948 1.948 0 01-.75-.832c-.49-.326-1.077-.375-1.55.017a.802.802 0 00-.865.13l-.408.376s.783.179 1.207.685c.05.049.13.163.261.326a.809.809 0 00-.816.294l-.342.457s.816.032 1.321.457c.278.228 1.404 1.37 3.9 2.806.392.082 1.159.212 1.746.31.277.326.49.67.522.963l2.725-.017c.098 0 .212 0 .326.017 1.746.212 2.318 1.795 2.318 1.795 3.785-1.028 7-2.448 9.561-4.26-.31.099-.636.148-.995.18z"
      fill={color}
    />
  </svg>
);

export const RightArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    width={15}
    height={10}
    viewBox="0 0 15 10"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.933205 5L13.5332 5M13.5332 5L9.3332 9.2M13.5332 5L9.3332 0.799998"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CompassRounded = ({ color = 'currentColor', ...props }) => (
  <svg
    width={30}
    height={32}
    viewBox="0 0 30 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={15} cy={15.533} r={15} fill={color} />
    <path
      d="M20 10.186l-11 4.49v.598l4.156 1.557 1.588 4.07h.612L20 10.186z"
      fill="#fff"
    />
  </svg>
);

export const ExternalArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    width={12}
    height={11}
    fill="none"
    viewBox="0 0 8 8"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m0.64552 6.6474c-0.19578 0.19475-0.19578 0.51049 0 0.70524 0.19578 0.19475 0.51319 0.19475 0.70896 0l-0.70896-0.70524zm6.5275-5.2893c0-0.27542-0.22444-0.49868-0.50131-0.49868l-4.5118 1e-6c-0.27687-1e-6 -0.50132 0.22326-0.50132 0.49868 0 0.27541 0.22445 0.49868 0.50132 0.49868h4.0105v3.9894c0 0.27541 0.22445 0.49868 0.50132 0.49868 0.27686 0 0.50131-0.22327 0.50131-0.49868v-4.4881zm-5.8186 5.9946 5.6717-5.6419-0.70897-0.70524-5.6717 5.6419 0.70896 0.70524z"
      fill="#C30024"
    />
  </svg>
);

export const CircelTickIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width={67}
    height={67}
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27.6921 41.3775L48.4911 20.5785L51.6388 23.7262L26.985 48.38L15.3652 36.7602L18.5129 33.6125L26.2779 41.3775L26.985 42.0846L27.6921 41.3775ZM1.91699 33.5017C1.91699 16.1322 16.1325 1.91666 33.502 1.91666C50.8715 1.91666 65.087 16.1322 65.087 33.5017C65.087 50.8711 50.8715 65.0867 33.502 65.0867C16.1325 65.0867 1.91699 50.8711 1.91699 33.5017ZM6.43399 33.5017C6.43399 48.3914 18.6123 60.5697 33.502 60.5697C48.3917 60.5697 60.57 48.3914 60.57 33.5017C60.57 18.612 48.3917 6.43366 33.502 6.43366C18.6123 6.43366 6.43399 18.612 6.43399 33.5017Z"
      fill={color}
      stroke="#ECEEF3"
      strokeWidth="2"
    />
  </svg>
);

export const Directions = ({ color = 'currentColor', ...props }) => (
  <svg
    width={14}
    height={11}
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.66675 9.83333V6.5H3.33342V10.5H0.666748V5.16667C0.666748 4.36667 1.20008 3.83333 2.00008 3.83333H8.66675V0.5L13.3334 5.16667L8.66675 9.83333Z"
      fill={color}
    />
  </svg>
);

export const Stripes = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="12"
    fill="none"
    viewBox="0 0 22 12"
    {...props}
  >
    <path
      fill={color}
      d="M8.587 11.385c0 .297.241.538.538.538h3.749a.538.538 0 000-1.077H9.125a.538.538 0 00-.538.539zM.681.077a.538.538 0 100 1.077h20.637a.538.538 0 100-1.077H.681zM3.761 6c0 .297.242.538.54.538h13.398a.538.538 0 000-1.076H4.3A.538.538 0 003.762 6z"
    ></path>
  </svg>
);

export const Tick = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    {...props}
  >
    <path
      d="M11.6 1.00005L4.40005 9.00005L0.800049 5.80005"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Phone = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M15.0858 22.2857C17.3144 23.6571 20.0573 23.3143 21.943 21.6L22.6287 20.9143C23.3144 20.2285 23.3144 19.0285 22.6287 18.3428L19.3715 15.0857C18.6858 14.4 17.4858 14.4 16.8001 15.0857C16.1144 15.7714 14.9144 15.7714 14.2287 15.0857L9.08583 9.94283C8.40011 9.25712 8.40011 8.05712 9.08583 7.3714C9.77154 6.68569 9.77154 5.48569 9.08583 4.79997L5.82868 1.3714C5.14297 0.685688 3.94297 0.685688 3.25725 1.3714L2.40011 2.22855C0.685825 3.94283 0.342968 6.85712 1.7144 8.91426C5.3144 14.2285 9.77154 18.6857 15.0858 22.2857Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Website = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M0.919922 12.04C0.919922 18.1545 5.84546 23.08 11.9599 23.08C18.0744 23.08 22.9999 18.1545 22.9999 12.04C22.9999 5.92554 18.0744 1 11.9599 1C5.84546 1 0.919922 5.92554 0.919922 12.04Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.919922 12.52H22.9999"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2796 12.04C16.126 16.1163 14.7436 20.0228 12.4396 23.08C10.1356 20.0228 8.75321 16.1163 8.59961 12.04C8.75321 7.96369 10.1356 4.05723 12.4396 1C14.7436 4.05723 16.126 7.96369 16.2796 12.04Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Email = ({ color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="21"
    viewBox="0 0 25 21"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        d="M0.892578 0.892883H24.1069V19.6429H0.892578V0.892883Z"
        stroke={color}
        strokeMiterlimit="40"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.892578 3.21429L11.4283 11.9643C11.964 12.5 13.0354 12.5 13.5712 11.9643L24.1069 3.21429"
        stroke={color}
        strokeMiterlimit="40"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="25" height="20.5357" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DarkIcon = ({
  color = 'currentColor',
  width = '24',
  height = '24',
  stroke = 'none',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    {...props}
  >
    <ellipse
      cx="12.4999"
      cy="11.9999"
      rx="10.9091"
      ry="10.9091"
      fill="#5B6885"
    />
    <circle
      cx="12.5"
      cy="12"
      r="11.25"
      transform="rotate(-180 12.5 12)"
      stroke="#5B6885"
      strokeWidth="1.5"
    />
    <path
      d="M12.5003 6.39854C12.0585 6.39854 11.7003 6.75671 11.7003 7.19854C11.7003 7.64036 12.0585 7.99854 12.5003 7.99854C12.9421 7.99854 13.3003 7.64036 13.3003 7.19854C13.3003 6.75671 12.9421 6.39854 12.5003 6.39854Z"
      fill="white"
    />
    <path
      d="M12.5 10.8003L12.5 17.2003"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const AlertIcon = ({
  color = 'currentColor',
  width = '24',
  height = '24',
  stroke = 'none',
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth={stroke}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="10.5" stroke={color} />
    <path
      d="M12.0002 17.6C12.442 17.6 12.8002 17.2418 12.8002 16.8C12.8002 16.3582 12.442 16 12.0002 16C11.5584 16 11.2002 16.3582 11.2002 16.8C11.2002 17.2418 11.5584 17.6 12.0002 17.6Z"
      fill={color}
    />
    <line
      x1="11.9004"
      y1="13.8999"
      x2="11.9004"
      y2="5.2999"
      stroke={color}
      strokeLinecap="round"
    />
  </svg>
);

export const ResultAlertIcon = ({ width = '24', height = '24', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_8370_13492)">
      <path
        d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
        stroke="#011E41"
        strokeWidth="2"
      />
      <path
        d="M12.0008 6.4C11.559 6.4 11.2008 6.75817 11.2008 7.2C11.2008 7.64183 11.559 8 12.0008 8C12.4426 8 12.8008 7.64183 12.8008 7.2C12.8008 6.75817 12.4426 6.4 12.0008 6.4Z"
        fill="#011E41"
      />
      <path
        d="M12 10.8L12 17.2"
        stroke="#011E41"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_8370_13492">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(24 24) rotate(-180)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ExternalLinkIcon = ({
  color = 'currentColor',
  width = 28,
  ...props
}) => (
  <svg
    width={width}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.7119 14.9435L21.4635 6.53356M21.4635 6.53356L21.466 12.1329M21.4635 6.53356L15.8637 6.53356"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.1321 6.5332L9.46582 6.5332C8.36125 6.5332 7.46582 7.42863 7.46582 8.5332L7.46582 18.5332C7.46582 19.6378 8.36125 20.5332 9.46582 20.5332L19.4646 20.5332C20.5692 20.5332 21.4646 19.6378 21.4646 18.5332L21.4646 15.8665"
      stroke={color}
      strokeLinecap="round"
    />
  </svg>
);

export const VideoPlayIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M32.4405 0C14.5997 0 0.0405273 14.5592 0.0405273 32.4C0.0405273 50.2408 14.5189 64.8 32.4405 64.8C50.3589 64.8 64.8405 50.2408 64.8405 32.4C64.8405 14.5592 50.2813 0 32.4405 0ZM32.4405 61.6C16.3589 61.6 3.24053 48.4816 3.24053 32.4C3.24053 16.3184 16.2813 3.2 32.4405 3.2C48.5997 3.2 61.6405 16.3184 61.6405 32.4C61.6405 48.4816 48.5189 61.6 32.4405 61.6Z"
      fill="#ffffff"
    />
    <path
      d="M23.0811 45.9183L46.5187 32.3999L23.0811 18.8815V45.9183Z"
      fill="#ffffff"
    />
  </svg>
);

export const HamburgerMenu = ({ color = 'currentColor', ...props }) => (
  <svg
    width="26"
    height="20"
    viewBox="0 0 26 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.43992 0.819824C0.876814 0.819824 0.419922 1.27672 0.419922 1.83982C0.419922 2.40293 0.876814 2.85982 1.43992 2.85982H24.5599C25.123 2.85982 25.5799 2.40293 25.5799 1.83982C25.5799 1.27672 25.123 0.819824 24.5599 0.819824H1.43992ZM1.43992 8.97983C0.876814 8.97983 0.419922 9.43672 0.419922 9.99983C0.419922 10.5629 0.876814 11.0198 1.43992 11.0198H24.5599C25.123 11.0198 25.5799 10.5629 25.5799 9.99983C25.5799 9.43672 25.123 8.97983 24.5599 8.97983H1.43992ZM1.43992 17.1398C0.876814 17.1398 0.419922 17.5967 0.419922 18.1598C0.419922 18.7229 0.876814 19.1798 1.43992 19.1798H24.5599C25.123 19.1798 25.5799 18.7229 25.5799 18.1598C25.5799 17.5967 25.123 17.1398 24.5599 17.1398H1.43992Z"
      fill="#5B6885"
    />
  </svg>
);

export const CloseMenuIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.05897 19.6876C0.759749 19.6829 0.491789 19.5009 0.377729 19.2243C0.262885 18.9477 0.323823 18.6298 0.532417 18.4149L18.416 0.531319C18.7074 0.240699 19.1793 0.240699 19.4699 0.531319C19.7605 0.821939 19.7605 1.29382 19.4699 1.58522L1.58632 19.4688C1.44647 19.6087 1.25664 19.6876 1.05898 19.6876H1.05897Z"
      fill={color}
    />
    <path
      d="M18.9423 19.6876C18.7446 19.6876 18.5548 19.6087 18.4149 19.4688L0.531319 1.58522C0.240699 1.29382 0.240699 0.821939 0.531319 0.531319C0.82194 0.240699 1.29382 0.240699 1.58522 0.531319L19.4688 18.4149C19.6774 18.6298 19.7384 18.9477 19.6235 19.2243C19.5094 19.5009 19.2415 19.6829 18.9423 19.6876H18.9423Z"
      fill={color}
    />
  </svg>
);

export const PreviousArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    width="22"
    height="40"
    viewBox="0 0 22 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 2L3 19.9444L20 37.8889"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const NextArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    width="22"
    height="40"
    viewBox="0 0 22 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 38L19 20.0556L2 2.11112"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const ClubBackArrow = ({ color = 'currentColor', ...props }) => (
  <svg
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 11L12.5 16L17.5 21"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FootballTypes = ({
  color = 'currentColor',
  height = 26,
  ...props
}) => (
  <svg
    width={24}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 13C1 19.6462 6.35385 25 13 25C19.6462 25 25 19.6462 25 13C25 6.35385 19.6462 1 13 1C6.35385 1 1 6.35385 1 13Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.78759 22.7199L5.79999 18.5183L9.23832 15.9536L14.4141 17.6634L15.5846 21.5013L12.4938 24.557C12.4755 24.557 9.38463 25.1936 6.78759 22.7199Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M1.66755 10.1457L5.6201 8.01514L9.06688 10.2754L9.12308 15.9815L5.75123 18.5382L1.76121 16.2039C1.76121 16.2039 0.11275 13.4619 1.66755 10.1457Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M12.348 1.39384L15.7693 4.64757L14.5252 8.4744L9.0549 10.2307L5.6154 7.91979L6.21914 3.55683C6.21914 3.55683 8.76218 1.09804 12.348 1.39384Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M23.7077 8.94527L22.1661 13.1845L17.8421 12.9944L14.4769 8.41299L15.7177 4.45893L19.7597 3.58447C19.7597 3.58447 22.8053 5.31437 23.7077 8.94527Z"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path
      d="M19.7844 22.4154L15.5294 21.8261L14.2923 17.758L17.7225 12.8154L21.9775 12.9865L24.0769 17.3588C24.0769 17.3588 23.0834 20.7236 19.7844 22.4154Z"
      stroke={color}
      strokeMiterlimit="10"
    />
  </svg>
);

export const TrophyIcon = ({
  color = 'currentColor',
  height = 32,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="32"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      d="M15.3056 2.32804V2.57804H15.5556H17.7778C18.297 2.57804 18.7974 2.79401 19.1683 3.18253C19.5395 3.57144 19.75 4.1013 19.75 4.65609V5.81853C19.7335 7.1688 19.2504 8.46535 18.3927 9.4683C17.5349 10.4713 16.3612 11.1123 15.0903 11.2759L14.9434 11.2948L14.8894 11.4328C14.559 12.2775 14.0363 13.0232 13.368 13.605C12.6997 14.1868 11.9064 14.587 11.058 14.7716L10.8611 14.8144V15.0159V18.6243V18.8743H11.1111H13.2275C14.2906 18.8743 15.1672 19.6726 15.2907 20.7024H4.70933C4.83281 19.6726 5.70943 18.8743 6.77249 18.8743H8.88889H9.13889V18.6243V15.0624V14.861L8.94204 14.8181C8.09356 14.6335 7.30025 14.2333 6.63203 13.6516C5.96374 13.0698 5.44097 12.3241 5.11061 11.4793L5.05665 11.3413L4.9097 11.3224C3.63164 11.1579 2.45217 10.5105 1.59341 9.49813C0.734524 8.48562 0.256 7.17788 0.25 5.81956V4.65609C0.25 4.1013 0.460479 3.57144 0.831713 3.18253C1.20257 2.79401 1.70301 2.57804 2.22222 2.57804H4.44444H4.69444V2.32804V0.25H15.3056V2.32804ZM1.97222 5.82011L1.97222 5.82078C1.97429 6.59017 2.2034 7.34108 2.62958 7.9706C3.05584 8.60025 3.65894 9.07831 4.35761 9.33708L4.69444 9.46184V9.10265V4.65609V4.40609H4.44444H2.22222H1.97222V4.65609L1.97222 5.82011ZM6.66667 2.07804H6.41667V2.32804V9.31217C6.41667 10.301 6.7915 11.2515 7.46214 11.9541C8.13315 12.657 9.04579 13.0542 10 13.0542C10.9542 13.0542 11.8668 12.657 12.5379 11.9541C13.2085 11.2515 13.5833 10.301 13.5833 9.31217V2.32804V2.07804H13.3333H6.66667ZM18.0278 5.82078V5.82011V4.65609V4.40609H17.7778H15.5556H15.3056V4.65609V9.10265V9.46184L15.6424 9.33708C16.3411 9.07831 16.9442 8.60025 17.3704 7.9706C17.7966 7.34108 18.0257 6.59017 18.0278 5.82078Z"
      fill="#ffffff"
      stroke="#5B6885"
      strokeWidth="0.8"
    />
  </svg>
);

export const Person = ({ color = 'currentColor', height = 25, ...props }) => (
  <svg
    width={24}
    height={height}
    viewBox="0 0 26 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.61292 7.05227C6.61292 10.1907 9.51614 12.96 13 12.96C16.4839 12.96 19.1936 10.1907 19.1936 7.05227C19.1936 3.91381 16.4839 0.959961 13 0.959961C9.51614 0.959961 6.61292 3.72919 6.61292 7.05227Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25 24.0001C22.871 17.7232 15.7097 14.2155 9.12903 16.2463C5.25806 17.3539 2.35484 20.3078 1 24.0001H25Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FaInitiative = ({
  color = 'currentColor',
  height = 26,
  ...props
}) => (
  <svg
    width={24}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 13C1 19.6462 6.35385 25 13 25C19.6462 25 25 19.6462 25 13C25 6.35385 19.6462 1 13 1C6.35385 1 1 6.35385 1 13Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.5001 22.5L15.5292 21.8261L12 25M24.0767 17.3588L21.9773 12.9865L24.0767 8.5M7.00011 23L6.00011 18.5L1.50011 16M1.50011 10L5.49963 8L6.49963 3M11.9996 1L15.5292 4.5L20.9996 4"
      stroke={color}
      strokeMiterlimit="10"
    />
    <path d="M9 10.5V16L14.5 17.5L17.5 13L14.5 8.5L9 10.5Z" stroke={color} />
  </svg>
);

export const Facilities = ({
  color = 'currentColor',
  height = 24,
  ...props
}) => (
  <svg
    width={24}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.84616 10.875H16.6154C17.1692 10.875 17.5385 11.225 17.5385 11.75V19.625C17.5385 21.55 15.8769 23.125 13.8462 23.125H4.61539C2.58462 23.125 0.92308 21.55 0.92308 19.625V11.75C0.92308 11.225 1.29231 10.875 1.84616 10.875Z"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    />
    <path
      d="M17.5385 12.625H19.3846C21.4154 12.625 23.0769 14.2 23.0769 16.125C23.0769 18.05 21.4154 19.625 19.3846 19.625H17.5385"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 4V9"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 4V9"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1V9"
      stroke={color}
      strokeMiterlimit="40"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Disability = ({
  color = 'currentColor',
  height = 26,
  ...props
}) => (
  <svg
    width={26}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.868 17.99C16.4267 20.3821 14.8538 22.521 12.4663 23.5828C8.61904 25.2947 4.11928 23.5564 2.41065 19.7056C0.702019 15.8548 2.43705 11.3427 6.28052 9.63086"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.87549 6.86133V14.8348L17.0829 14.797L21.858 22.1659L24.2456 21.0851"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M16.4342 10.9727H9.27533"
      stroke={color}
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.78125 6.78945C10.1686 6.78945 11.2933 5.66265 11.2933 4.27266C11.2933 2.88267 10.1686 1.75586 8.78125 1.75586C7.3939 1.75586 6.26923 2.88267 6.26923 4.27266C6.26923 5.66265 7.3939 6.78945 8.78125 6.78945Z"
      stroke={color}
      strokeMiterlimit="10"
    />
  </svg>
);

export const Pitch = ({ color = 'currentColor', height = 26, ...props }) => (
  <svg
    width={24}
    height={height}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="1.5" y="1.5" width="23" height="23" stroke={color} />
    <line x1="1" y1="13.022" x2="25" y2="13.022" stroke={color} />
    <path
      d="M18.1842 12.9999C18.1842 15.2319 15.9568 17.1955 13 17.1955C10.0432 17.1955 7.8158 15.2319 7.8158 12.9999C7.8158 10.7678 10.0432 8.8042 13 8.8042C15.9568 8.8042 18.1842 10.7678 18.1842 12.9999Z"
      stroke={color}
    />
    <path
      d="M18.6842 2.04346C18.6842 4.74955 16.1393 6.94327 13 6.94327C9.8607 6.94327 7.3158 4.74955 7.3158 2.04346"
      stroke={color}
    />
    <path
      d="M7.31578 23.9565C7.31578 21.2505 9.86069 19.0567 13 19.0567C16.1393 19.0567 18.6842 21.2505 18.6842 23.9565"
      stroke={color}
    />
  </svg>
);

export const Facebook = ({ color = 'currentColor', height = 26, ...props }) => (
  <svg
    width={9}
    height={18}
    viewBox="0 0 9 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.41025 10.125L8.87695 6.86742H5.95889V4.75348C5.95889 3.86227 6.36652 2.99355 7.67343 2.99355H9.00003V0.220078C9.00003 0.220078 7.79618 0 6.64516 0C4.24205 0 2.67126 1.56023 2.67126 4.38469V6.86742H0V10.125H2.67126V18H5.95889V10.125H8.41025Z"
      fill={color}
    />
  </svg>
);

export const Twitter = ({ color = 'currentColor', height = 26, ...props }) => (
  <svg
    width={25}
    height={18}
    viewBox="0 0 25 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.4303 4.48592C22.4461 4.68279 22.4461 4.87969 22.4461 5.07656C22.4461 11.0812 17.2907 18 7.86805 18C4.96511 18 2.26842 17.2547 0 15.961C0.412453 16.0031 0.808988 16.0172 1.23731 16.0172C3.63258 16.0172 5.83757 15.3 7.59837 14.0766C5.34582 14.0344 3.45812 12.7266 2.80773 10.9266C3.12501 10.9687 3.44225 10.9969 3.77541 10.9969C4.23542 10.9969 4.69548 10.9406 5.12375 10.8422C2.77604 10.4203 1.01519 8.59218 1.01519 6.38437V6.32814C1.69727 6.66564 2.49049 6.87657 3.33117 6.90467C1.95108 6.08902 1.04693 4.69685 1.04693 3.12184C1.04693 2.27811 1.30069 1.50467 1.74488 0.829666C4.26711 3.58591 8.05838 5.38588 12.3096 5.58279C12.2303 5.24529 12.1827 4.89376 12.1827 4.54219C12.1827 2.03904 14.467 0 17.3065 0C18.7817 0 20.1142 0.548436 21.0501 1.43437C22.2081 1.23751 23.3185 0.857802 24.302 0.337502C23.9213 1.39221 23.1123 2.27815 22.0495 2.84061C23.0806 2.74222 24.08 2.48904 25 2.13752C24.3021 3.03748 23.4296 3.83901 22.4303 4.48592Z"
      fill={color}
    />
  </svg>
);

export const Instagram = ({
  color = 'currentColor',
  height = 26,
  ...props
}) => (
  <svg
    width={17}
    height={18}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.50191 4.38503C6.08986 4.38503 4.14429 6.4455 4.14429 9C4.14429 11.5545 6.08986 13.615 8.50191 13.615C10.914 13.615 12.8595 11.5545 12.8595 9C12.8595 6.4455 10.914 4.38503 8.50191 4.38503ZM8.50191 12.0003C6.94318 12.0003 5.66889 10.6548 5.66889 9C5.66889 7.3452 6.93939 5.99967 8.50191 5.99967C10.0644 5.99967 11.3349 7.3452 11.3349 9C11.3349 10.6548 10.0606 12.0003 8.50191 12.0003ZM14.0542 4.19625C14.0542 4.79471 13.5991 5.27268 13.0378 5.27268C12.4727 5.27268 12.0214 4.79069 12.0214 4.19625C12.0214 3.60181 12.4765 3.11983 13.0378 3.11983C13.5991 3.11983 14.0542 3.60181 14.0542 4.19625ZM16.9403 5.28874C16.8758 3.84681 16.5648 2.56956 15.5674 1.51724C14.5738 0.464911 13.3677 0.135557 12.0062 0.0632601C10.603 -0.0210867 6.39706 -0.0210867 4.99382 0.0632601C3.63609 0.131541 2.43007 0.460895 1.43263 1.51322C0.435193 2.56555 0.127998 3.8428 0.0597324 5.28473C-0.0199108 6.77084 -0.0199108 11.2251 0.0597324 12.7113C0.124205 14.1532 0.435193 15.4304 1.43263 16.4828C2.43007 17.5351 3.6323 17.8644 4.99382 17.9367C6.39706 18.0211 10.603 18.0211 12.0062 17.9367C13.3677 17.8685 14.5738 17.5391 15.5674 16.4828C16.561 15.4304 16.872 14.1532 16.9403 12.7113C17.0199 11.2251 17.0199 6.77485 16.9403 5.28874ZM15.1275 14.3058C14.8316 15.093 14.259 15.6995 13.5118 16.0168C12.3931 16.4868 9.73828 16.3783 8.50191 16.3783C7.26555 16.3783 4.60698 16.4828 3.49197 16.0168C2.74864 15.7036 2.17597 15.0971 1.87636 14.3058C1.43263 13.1209 1.53503 10.3094 1.53503 9C1.53503 7.69062 1.43642 4.87504 1.87636 3.69419C2.17217 2.90695 2.74485 2.30046 3.49197 1.98315C4.61077 1.51322 7.26555 1.62167 8.50191 1.62167C9.73828 1.62167 12.3968 1.51724 13.5118 1.98315C14.2552 2.29644 14.8279 2.90293 15.1275 3.69419C15.5712 4.87906 15.4688 7.69062 15.4688 9C15.4688 10.3094 15.5712 13.125 15.1275 14.3058Z"
      fill={color}
    />
  </svg>
);

export const DateIcon = ({ color = 'currentColor', height = 26, ...props }) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 4H18V2H16V4H8V2H6V4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM9 14H7V12H9V14ZM13 14H11V12H13V14ZM17 14H15V12H17V14ZM9 18H7V16H9V18ZM13 18H11V16H13V18ZM17 18H15V16H17V18Z"
      fill="#5B6885"
    />
  </svg>
);

export const CupIconNew = ({
  color = 'currentColor',
  height = 26,
  ...props
}) => (
  <svg
    width={22}
    height={20}
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 3V11C15 11.5304 14.7893 12.0391 14.4142 12.4142C14.0391 12.7893 13.5304 13 13 13H7C6.46957 13 5.96086 12.7893 5.58579 12.4142C5.21071 12.0391 5 11.5304 5 11V3H15ZM19 1H3V11C3 12.0609 3.42143 13.0783 4.17157 13.8284C4.92172 14.5786 5.93913 15 7 15H13C14.0609 15 15.0783 14.5786 15.8284 13.8284C16.5786 13.0783 17 12.0609 17 11V8H19C19.5304 8 20.0391 7.78929 20.4142 7.41421C20.7893 7.03914 21 6.53043 21 6V3C21 2.46957 20.7893 1.96086 20.4142 1.58579C20.0391 1.21071 19.5304 1 19 1ZM17 6V3H19V6H17ZM19 17H1V19H19V17Z"
      fill="#ECEEF3"
      stroke="#5B6885"
    />
  </svg>
);

export const ArrowTriangle = ({ color = 'currentColor', ...props }) => (
  <svg
    width={8}
    height={4}
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4 4L3.49691e-07 -6.99382e-07L8 0L4 4Z" fill={color} />
  </svg>
);

export const ShowMore = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M5.06208 7.23281L11.4899 1.05645M11.4899 1.05645L11.4917 5.16863M11.4899 1.05645L7.37698 1.05645"
      stroke="#011E41"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.33333 1L3 1C1.89543 1 1 1.89543 1 3L0.999999 9C0.999998 10.1046 1.89543 11 3 11L9 11C10.1046 11 11 10.1046 11 9L11 7.66667"
      stroke="#011E41"
      strokeLinecap="round"
    />
  </svg>
);

export const AlertLocation = ({ animationId, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M14.3046 4.42635C13.8311 3.54382 12.9512 3 11.9987 3C11.0462 3 10.1663 3.54382 9.69276 4.42635L3.39893 16.1782C2.86393 17.1756 2.86722 18.4004 3.40772 19.3943C3.94822 20.3883 4.94244 21 6.01907 21L17.9782 21C19.0548 21.0012 20.0512 20.3894 20.5917 19.3955C21.1322 18.4016 21.1366 17.1757 20.6016 16.1782L14.3046 4.42635ZM17.9782 19.1996L6.01906 19.1996C5.54447 19.1996 5.10503 18.93 4.86553 18.4917C4.62714 18.0534 4.62494 17.5131 4.86114 17.0724L11.155 5.31929C11.3274 4.99582 11.6493 4.79539 11.9987 4.79539C12.348 4.79539 12.6699 4.99581 12.8424 5.31929L19.1362 17.0724C19.3724 17.5131 19.3702 18.0533 19.1318 18.4917C18.8923 18.93 18.4529 19.1996 17.9783 19.1996H17.9782Z"
      fill="#E1261C"
    />
    <path
      d="M11 8.91602L13 8.91602L13 12.916L11 12.916L11 8.91602Z"
      fill="#E1261C"
    />
    <path
      d="M13 15.916C13 17.2493 11 17.2493 11 15.916C11 14.5827 13 14.5827 13 15.916Z"
      fill="#E1261C"
    />
  </svg>
);

export const LoadingLocation = ({ animationId, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g mask="url(#mask0_2401_42597)">
      <path
        d="M7.0001 20.6604C5.81653 19.977 4.82916 19.1039 4.038 18.0409C3.24684 16.9779 2.68502 15.826 2.35254 14.5852C2.02007 13.3443 1.93067 12.0659 2.08434 10.7497C2.23801 9.43353 2.65651 8.18367 3.33984 7.0001C4.03151 5.8021 4.90676 4.81112 5.96559 4.02717C7.02442 3.24323 8.17424 2.68502 9.41504 2.35254C10.6558 2.02007 11.9343 1.93067 13.2505 2.08434C14.5667 2.23801 15.8165 2.65651 17.0001 3.33984C17.2455 3.48151 17.4032 3.68325 17.4734 3.94508C17.5435 4.2069 17.5078 4.4605 17.3661 4.70587C17.2245 4.95124 17.0227 5.10901 16.7609 5.17916C16.4991 5.24932 16.2455 5.21356 16.0001 5.07189C14.0804 3.96356 12.0562 3.69459 9.92748 4.26498C7.79876 4.83537 6.18023 6.08041 5.07189 8.0001C3.96356 9.91979 3.69459 11.944 4.26498 14.0727C4.83537 16.2014 6.08041 17.82 8.0001 18.9283C9.91979 20.0366 11.944 20.3056 14.0727 19.7352C16.2014 19.1648 17.82 17.9198 18.9283 16.0001C19.07 15.7547 19.2717 15.597 19.5335 15.5268C19.7954 15.4567 20.049 15.4924 20.2943 15.6341C20.5397 15.7757 20.6975 15.9775 20.7676 16.2393C20.8378 16.5011 20.802 16.7547 20.6604 17.0001C19.977 18.1837 19.1039 19.171 18.0409 19.9622C16.9779 20.7534 15.826 21.3152 14.5852 21.6477C13.3443 21.9801 12.0695 22.0716 10.7605 21.9221C9.45157 21.7726 8.1981 21.352 7.0001 20.6604Z"
        fill="url(#paint0_linear_2401_42597)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2401_42597"
        x1="10.7991"
        y1="17.0802"
        x2="32.7668"
        y2="28.0312"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="red" />
        <stop offset="0.24751" stopColor="red" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);
//using old animation
export const SpinningBadge = ({ animationId, ...props }) => (
  <svg
    id="ef-logo-loading-v3-01"
    xmlns="http://www.w3.org/2000/svg"
    // xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 91.340000 93.690000"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    {...props}
  >
    <defs>
      <linearGradient
        id="ef-logo-loading-v3-01-path15-stroke"
        x1="3.620000"
        y1="46.840000"
        x2="87.720000"
        y2="46.840000"
        spreadMethod="pad"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-0"
          offset="0%"
          stopColor="rgb(255,255,255)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-1"
          offset="3%"
          stopColor="rgb(251,227,226)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-2"
          offset="7%"
          stopColor="rgb(246,188,185)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-3"
          offset="12%"
          stopColor="rgb(241,152,147)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-4"
          offset="18%"
          stopColor="rgb(236,121,115)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-5"
          offset="24%"
          stopColor="rgb(233,95,87)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-6"
          offset="30%"
          stopColor="rgb(230,74,65)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-7"
          offset="38%"
          stopColor="rgb(228,58,49)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-8"
          offset="48%"
          stopColor="rgb(226,46,37)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-9"
          offset="62%"
          stopColor="rgb(225,40,30)"
        />
        <stop
          id="ef-logo-loading-v3-01-path15-stroke-10"
          offset="100%"
          stopColor="rgb(225,38,28)"
        />
      </linearGradient>
    </defs>
    <g id="ef-logo-loading-v3-01-layer-1">
      <path
        id="ef-logo-loading-v3-01-path1"
        d="M58.700000,33.840000L58.490000,33.840000C56.955205,33.754328,55.444996,33.416473,54.020000,32.840000C53.190000,32.530000,52.250000,32.210000,51.320000,31.900000C51.010000,33.360000,52.320000,34.720000,54.440000,34.620000C55.160000,34.620000,55.440000,34.410000,56,34.410000C56.366732,34.392186,56.683184,34.664686,56.720000,35.030000C56.720000,35.450000,56.410000,35.760000,55.790000,35.760000C55.503791,35.742219,55.222895,35.674533,54.960000,35.560000C54.475624,35.542173,54.062283,35.907144,54.020000,36.390000C53.827227,36.491378,53.707500,36.692210,53.710000,36.910000L53.710000,37.330000C53.983102,37.138119,54.306389,37.030356,54.640000,37.020000L55.480000,37.020000C55.263328,37.261373,54.963101,37.411486,54.640000,37.440000C54.333315,37.740621,54.252816,38.203489,54.440000,38.590000C54.329716,38.745791,54.329716,38.954209,54.440000,39.110000L54.640000,39.530000C54.783518,39.201593,55.043576,38.937973,55.370000,38.790000C55.580000,38.690000,56.100000,38.380000,56.100000,38.380000C55.906707,38.813863,56.092590,39.322829,56.520000,39.530000C56.520000,39.740000,56.620000,39.840000,56.830000,39.940000L57.240000,40.150000C57.247381,39.806528,57.318593,39.467426,57.450000,39.150000C57.660000,38.730000,58.280000,37.690000,58.280000,37.690000L59.220000,37.690000L59.220000,35.690000C59.315898,34.916528,59.639615,34.189036,60.150000,33.600000C59.705685,33.835726,59.196572,33.919993,58.700000,33.840000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path2"
        d="M63.790000,29.870000C63.189450,29.925091,62.591790,29.737873,62.130000,29.350000L61.610000,28.930000L63.690000,28.930000C63.690000,28.930000,67.330000,28.720000,68.370000,26.530000C68.677121,25.843648,68.784562,25.084627,68.680000,24.340000C68.584754,23.591079,68.255832,22.891245,67.740000,22.340000C67.042597,21.570088,66.037705,21.151995,65,21.200000C61.470000,21.200000,59.070000,23.710000,54.810000,23.920000C52.210000,24.020000,48.060000,24.020000,44.630000,24.020000C44.310000,24.020000,44.110000,23.810000,44.210000,23.500000C44.224602,23.274365,44.404365,23.094602,44.630000,23.080000L54.290000,22.980000C55.071165,22.937122,55.801273,22.578294,56.312430,21.986031C56.823588,21.393767,57.071804,20.619039,57,19.840000C56.780284,20.337707,56.293830,20.664604,55.750000,20.680000C55.750000,20.470000,55.850000,20.260000,55.850000,19.950000C55.206333,20.393281,54.450812,20.646276,53.670000,20.680000L52.730000,20.680000C51.955139,20.673179,51.219215,21.019063,50.730000,21.620000L44.670000,21.620000C43.681172,21.647255,42.871208,22.414136,42.790000,23.400000C42.705177,23.978574,42.877814,24.565290,43.262472,25.005723C43.647129,25.446157,44.205274,25.696185,44.790000,25.690000C47.700000,25.690000,54.560000,25.690000,55.910000,25.590000C57.302525,25.420965,58.673404,25.105897,60,24.650000C61.450000,24.230000,63.110000,23.080000,65.090000,23.190000C66.020658,23.154957,66.827614,23.828139,66.960000,24.750000C66.993262,25.112957,66.920302,25.477756,66.750000,25.800000C66.020000,27.260000,62.700000,27.470000,59.160000,27.260000C53.340000,26.840000,48.670000,26.320000,42.840000,27.260000C42.083905,27.350036,41.347566,27.562831,40.660000,27.890000C40.694272,28.745771,40.554799,29.599615,40.250000,30.400000L40.040000,30.810000L39.620000,30.400000C39.591651,30.400142,39.564574,30.388245,39.545505,30.367269C39.526435,30.346292,39.517165,30.318207,39.520000,30.290000C39.234047,30.694921,38.919937,31.079205,38.580000,31.440000L38.370000,31.650000L38.060000,31.550000C37.942144,31.462841,37.795657,31.423540,37.650000,31.440000C37.277136,31.477873,36.956751,31.721057,36.820000,32.070000C36.190000,33.640000,35.570000,33.740000,34.110000,33.840000L33.700000,33.840000C33.447544,33.679845,33.203860,33.506262,32.970000,33.320000C31.207865,33.271527,29.459667,32.992488,27.770000,32.490000C27.214761,32.264878,26.848372,31.729082,26.840000,31.130000L26.840000,30.920000C26.667725,30.524522,26.271098,30.274648,25.840000,30.290000C25.672528,30.128388,25.440945,30.051193,25.210000,30.080000L24.800000,30.190000C25.075980,30.407409,25.289821,30.693680,25.420000,31.020000L25.630000,31.650000C25.318828,31.534611,25.059663,31.310947,24.900000,31.020000C24.480399,30.821834,23.981809,30.905597,23.650000,31.230000C23.419864,31.136188,23.155757,31.225644,23.030000,31.440000L22.720000,31.750000C23.054200,31.828669,23.370010,31.971293,23.650000,32.170000L24.280000,32.700000C23.810571,32.721439,23.419397,33.066837,23.340000,33.530000C23.130000,33.640000,22.930000,33.740000,22.930000,34.050000L22.820000,34.470000C23.298238,34.359142,23.791113,34.325383,24.280000,34.370000L25.730000,34.780000L27.810000,34.780000C28.442864,34.785433,28.954567,35.297136,28.960000,35.930000C30.451756,36.506712,31.822112,37.358097,33,38.440000C33.380121,38.156991,33.716991,37.820121,34,37.440000C34.409017,37.549700,34.827590,37.620020,35.250000,37.650000C36.925093,36.464391,38.521758,35.171693,40.030000,33.780000C41.331339,32.724981,42.811471,31.912094,44.400000,31.380000C44.627312,31.823408,44.943956,32.214957,45.330000,32.530000C47.031683,31.272740,49.194129,30.813266,51.260000,31.270000C53.960000,32,56.040000,33.270000,58.530000,33.270000C59.807406,33.283228,61.077045,33.069929,62.280000,32.640000C62.719247,32.512914,63.172904,32.442345,63.630000,32.430000C64.265127,32.430000,64.780000,32.944873,64.780000,33.580000C64.780000,34.215127,64.265127,34.730000,63.630000,34.730000C63.205334,34.722681,62.819947,34.479888,62.630000,34.100000C62.239310,33.838153,61.718955,33.883945,61.380000,34.210000C61.133918,34.200502,60.900051,34.317436,60.760000,34.520000L60.550000,34.940000C60.866077,34.938275,61.181360,34.971815,61.490000,35.040000L62.110000,35.360000C62,35.360000,61.900000,35.460000,61.690000,35.460000C61.480000,35.460000,61.380000,35.460000,61.280000,35.360000C60.773446,35.436477,60.385027,35.849688,60.340000,36.360000L60.340000,36.880000C60.145638,36.984746,60.026025,37.189246,60.030000,37.410000L60.030000,37.820000C60.459456,37.641768,60.915811,37.536976,61.380000,37.510000L65.230000,37.510000L66.060000,35.510000L66.890000,35.510000L66.890000,34.260000C66.902482,33.384716,67.577593,32.662001,68.450000,32.590000C68.370000,30.710000,66.290000,29.870000,63.790000,29.870000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path3"
        d="M40.090000,27.260000C40.584962,27.124692,41.023236,26.833678,41.340000,26.430000C41.734043,25.537676,41.769847,24.527993,41.440000,23.610000C40.926592,23.343511,40.358368,23.199744,39.780000,23.190000L39.470000,23.190000C38.933561,22.115811,38.001607,21.291390,36.870000,20.890000C36.788906,21.045125,36.684340,21.186795,36.560000,21.310000L36.450000,21.310000C36.124190,21.222749,35.786986,21.185657,35.450000,21.200000C34.749294,21.195161,34.059612,21.374478,33.450000,21.720000C32.899400,21.337523,32.250041,21.122228,31.580000,21.100000L31.470000,21.100000C30.778417,21.767785,30.340130,22.654963,30.230000,23.610000C30.262843,24.130822,30.478931,24.623220,30.840000,25C30.547570,25.807041,30.165159,26.578572,29.700000,27.300000L30.320000,27.620000C30.321439,28.223379,30.426291,28.822047,30.630000,29.390000C31.010536,29.360750,31.384274,29.502836,31.649268,29.777502C31.914263,30.052167,32.042866,30.430757,32,30.810000C31.900000,32.380000,32.210000,32.490000,33.670000,33.430000C35.430000,33.220000,35.750000,33.320000,36.370000,31.860000C36.570394,31.352576,37.054618,31.014012,37.600000,31C37.819126,31.025660,38.030384,31.097215,38.220000,31.210000C38.612282,30.803114,38.948577,30.345753,39.220000,29.850000C39.430000,29.960000,39.530000,29.960000,39.740000,30.060000C40.140078,29.184369,40.262228,28.207169,40.090000,27.260000ZM32.610000,24.440000L32.610000,24.440000L33.440000,24.750000C33.340000,24.750000,33.340000,24.860000,33.230000,24.960000C33.161659,25.068879,33.145616,25.202624,33.186267,25.324578C33.226918,25.446531,33.320000,25.543901,33.440000,25.590000C33.518542,25.601198,33.591801,25.636083,33.650000,25.690000C33.809499,25.687166,33.959584,25.613954,34.060000,25.490000C34.144756,25.406445,34.185469,25.288007,34.170000,25.170000C34.512873,25.345909,34.684340,25.739030,34.580000,26.110000C34.488003,26.507822,34.350428,26.893705,34.170000,27.260000C33.989572,27.626295,33.850000,27.160000,34.060000,26.640000C34.270000,26.120000,34.170000,26.110000,34.170000,26.110000L34,26.110000C33.738517,26.138741,33.476241,26.063291,33.270000,25.900000C32.856155,25.526572,32.616929,24.997376,32.610000,24.440000ZM35.830000,29.870000C35,30.290000,35.520000,31.230000,35.210000,31.750000C35.069652,32.020627,34.784501,32.184686,34.480000,32.170000C34.301275,32.177204,34.123305,32.142979,33.960000,32.070000C33.340000,31.960000,33.020000,31.650000,33.020000,31.230000C33.020000,30.810000,33.850000,29.980000,33.340000,29.230000C33.120368,28.958688,32.975570,28.634617,32.920000,28.290000C33.100184,28.381382,33.273921,28.484956,33.440000,28.600000C33.606079,28.715044,33.650000,28.700000,33.960000,28.810000L34.270000,28.810000C34.520896,28.810729,34.737928,28.635434,34.790000,28.390000C34.890000,28.180000,34.690000,28.080000,34.580000,27.970000C34.432756,27.922648,34.317352,27.807244,34.270000,27.660000C34.212161,27.525974,34.212161,27.374026,34.270000,27.240000C34.479632,27.502510,34.772335,27.685890,35.100000,27.760000L35.520000,27.760000C35.730244,27.754922,35.938821,27.721280,36.140000,27.660000C36.341179,27.598720,36.140000,27.970000,35.930000,27.970000C35.784343,27.953540,35.637856,27.992841,35.520000,28.080000C35.410000,28.080000,35.210000,28.180000,35.210000,28.290000C35.100000,28.700000,35.410000,28.910000,35.730000,28.910000C35.905161,28.937421,36.078739,28.974140,36.250000,29.020000C36.429311,29.021995,36.606857,28.984437,36.770000,28.910000C36.599778,29.344207,36.260528,29.690676,35.830000,29.870000ZM38.830000,25.870000C38.585142,26.358955,38.126919,26.706318,37.590000,26.810000L37.480000,26.810000C37.146389,26.799644,36.823102,26.691881,36.550000,26.500000C36.276898,26.308119,36.440000,26.500000,36.340000,27.020000C36.240000,27.540000,36.030000,27.440000,35.920000,27.440000C35.919020,27.047044,35.990201,26.657248,36.130000,26.290000C36.266935,25.940871,36.630456,25.736129,37,25.800000C36.923044,25.883800,36.886520,25.997027,36.900000,26.110000C36.839381,26.322210,36.919321,26.549569,37.099409,26.677146C37.279498,26.804723,37.520502,26.804723,37.700591,26.677146C37.880679,26.549569,37.960619,26.322210,37.900000,26.110000C37.900000,26.010000,37.900000,26.010000,37.790000,25.900000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path4"
        d="M32.710000,61.740000C34.583611,61.676063,36.310109,62.750680,37.080000,64.460000C39.255290,65.731951,41.553653,66.780621,43.940000,67.590000C47.127935,67.718671,50.320790,67.648535,53.500000,67.380000C53.288088,66.627977,53.288088,65.832023,53.500000,65.080000C53.583956,64.732048,53.506832,64.364787,53.290000,64.080000C53.088183,63.808877,52.792006,63.623321,52.460000,63.560000L52.050000,63.560000L51.940000,63.240000C51.664379,62.577932,51.524939,61.867130,51.530000,61.150000C48.833074,61.113346,46.161885,60.619683,43.630000,59.690000C43.378476,59.997097,43.097097,60.278476,42.790000,60.530000C40.082876,59.909797,37.465329,58.948798,35,57.670000C34.732831,57.758623,34.450573,57.792630,34.170000,57.770000C32.751845,57.764222,31.574273,56.673555,31.460000,55.260000L31.460000,54.530000C31.165224,53.838577,30.444858,53.429278,29.700000,53.530000C29.402864,53.223011,28.962997,53.100613,28.550000,53.210000L27.830000,53.420000C28.275142,53.845065,28.667924,54.321775,29,54.840000L29.310000,55.840000C28.793118,55.656030,28.352945,55.303891,28.060000,54.840000C27.373421,54.467784,26.522950,54.598626,25.980000,55.160000C25.571902,55.047595,25.134976,55.166408,24.840000,55.470000L24.320000,56.100000C24.929923,56.186092,25.504303,56.438681,25.980000,56.830000L26.980000,57.770000C26.153411,57.808797,25.464019,58.415130,25.320000,59.230000C24.908570,59.333721,24.588786,59.657357,24.490000,60.070000L24.390000,60.800000C25.382120,60.643812,26.389682,60.610227,27.390000,60.700000L30.300000,61.700000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path5"
        d="M58.390000,63.100000C57.981604,63.334966,57.500472,63.409809,57.040000,63.310000C56.930000,63.310000,56.930000,63.310000,56.830000,63.200000C57.186602,63.947252,57.106032,64.829684,56.620000,65.500000C56.520000,65.810000,56.310000,66.020000,56.310000,66.230000C56.310000,66.440000,56.410000,66.860000,57.240000,67.070000C58.070000,67.280000,58.240000,67.070000,58.490000,66.750000C58.579162,66.482952,58.613183,66.200583,58.590000,65.920000C58.513374,65.106401,58.870443,64.312492,59.530000,63.830000L59.320000,63.830000C58.916806,63.737201,58.575908,63.469615,58.390000,63.100000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path6"
        d="M67.330000,59C67.722209,57.961072,67.757392,56.821138,67.430000,55.760000C66.682851,55.368933,65.840849,55.195682,65,55.260000C64.220581,53.886014,62.899789,52.902677,61.360000,52.550000L60.530000,52.340000C59.022471,52.006132,57.444737,52.241189,56.100000,53C55.421091,52.544941,54.627020,52.291809,53.810000,52.270000C53.046504,53.081057,52.541734,54.101040,52.360000,55.200000C52.403210,55.703880,52.631150,56.174006,53,56.520000C51.984215,57.438377,51.352156,58.706067,51.230000,60.070000C51.476829,60.068780,51.722592,60.102446,51.960000,60.170000C51.915340,61.051259,52.020154,61.933721,52.270000,62.780000C52.812156,62.815165,53.307684,63.098748,53.612650,63.548377C53.917615,63.998005,53.997832,64.563277,53.830000,65.080000C53.310000,67.490000,54.250000,67.900000,56.430000,69.470000C59.130000,69.160000,60.170000,69.160000,60.800000,66.750000C60.918086,66.223222,61.266373,65.777258,61.748843,65.535055C62.231312,65.292851,62.797017,65.279984,63.290000,65.500000C64.744228,64.349917,65.740585,62.718871,66.100000,60.900000C65.773579,60.699765,65.576177,60.342923,65.580000,59.960000C66.490000,59.860000,67.220000,59.440000,67.330000,59ZM56.410000,58.590000C55.869147,58.159939,55.561775,57.500755,55.580000,56.810000L55.580000,56.600000L55.680000,56.600000L56.680000,57.120000C56.580000,57.230000,56.480000,57.230000,56.480000,57.330000C56.320249,57.533364,56.289679,57.809740,56.401123,58.043102C56.512567,58.276463,56.746733,58.426412,57.005315,58.429997C57.263896,58.433581,57.502129,58.290182,57.620000,58.060000C57.699478,57.938894,57.734794,57.794099,57.720000,57.650000C58.156587,57.851467,58.411727,58.313150,58.350000,58.790000C58.254332,59.352263,58.039528,59.887566,57.720000,60.360000C57.400472,60.832434,57.410000,60.150000,57.620000,59.630000C57.930000,58.900000,57.720000,58.900000,57.720000,58.900000C57.263705,58.943455,56.805321,58.841981,56.410000,58.610000ZM60,64.350000C58.850000,64.870000,59.480000,66.350000,59.060000,67.070000C58.640000,67.790000,58.120000,67.800000,57.290000,67.590000C56.460000,67.380000,55.940000,67.070000,55.940000,66.340000C55.940000,65.610000,57.190000,64.560000,56.360000,63.520000C56.038313,63.127273,55.821548,62.659335,55.730000,62.160000C55.953448,62.359679,56.198265,62.534070,56.460000,62.680000C56.696828,62.798028,56.940610,62.901553,57.190000,62.990000C57.408707,63.089623,57.659859,63.089558,57.878515,62.989820C58.097170,62.890083,58.261860,62.700466,58.330000,62.470000C58.440000,62.160000,58.230000,62.050000,58.020000,61.840000C57.810000,61.630000,57.810000,61.740000,57.710000,61.640000C57.610000,61.540000,57.710000,61.010000,57.710000,61.010000C58.280516,61.660391,59.204543,61.870214,60,61.530000C60.795457,61.189786,60,61.950000,59.680000,62.050000C59.580000,62.050000,59.370000,62.160000,59.270000,62.160000C59.170000,62.160000,58.750000,62.260000,58.750000,62.580000C58.640000,63.200000,59.060000,63.520000,59.580000,63.580000C59.816769,63.650554,60.062979,63.684281,60.310000,63.680000C60.589978,63.685568,60.869357,63.651908,61.140000,63.580000C61.410643,63.508092,61,63.830000,60,64.350000ZM63.840000,58.810000C63.529026,59.478627,62.907625,59.950294,62.180000,60.070000L62,60.070000C61.557519,60.038500,61.130545,59.893880,60.760000,59.650000C60.389455,59.406120,60.650000,59.650000,60.550000,60.380000C60.450000,61.110000,60.030000,61.010000,60.030000,61.010000C60.031467,60.479764,60.102062,59.951982,60.240000,59.440000C60.407556,58.963972,60.877536,58.663021,61.380000,58.710000C61.280000,58.810000,61.280000,58.920000,61.280000,59.130000C61.280000,59.472417,61.557583,59.750000,61.900000,59.750000C62.242417,59.750000,62.520000,59.472417,62.520000,59.130000C62.533794,59.013956,62.497414,58.897541,62.420000,58.810000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path7"
        d="M34.790000,29C34.580000,29.210000,34.270000,29.210000,33.850000,29.100000L33.750000,29.100000C34.036094,29.595668,33.996669,30.214636,33.650000,30.670000C33.551189,30.830257,33.480188,31.006068,33.440000,31.190000C33.440000,31.400000,33.540000,31.610000,34.060000,31.710000C34.580000,31.810000,34.790000,31.710000,34.890000,31.510000C34.984120,31.357666,35.022961,31.177587,35,31C34.909803,30.465374,35.155694,29.929965,35.620000,29.650000L35.520000,29.650000C35.172174,29.591205,34.888593,29.338702,34.790000,29Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path8"
        d="M59.430000,49.100000C62.105383,48.921574,64.712521,49.992495,66.490000,52C67.010000,52.110000,67.640000,52.420000,68.490000,52.630000C68.490000,52,68.590000,51.480000,68.590000,50.850000L68.590000,46.850000C65.383170,46.696774,62.200886,47.478448,59.430000,49.100000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path9"
        d="M45.290000,44.710000C44.919147,44.946864,44.467895,45.022674,44.040000,44.920000C43.940000,44.920000,43.940000,44.920000,43.830000,44.810000C44.197617,45.481889,44.118370,46.310024,43.630000,46.900000C43.520000,47.110000,43.310000,47.430000,43.420000,47.640000C43.530000,47.850000,43.520000,48.160000,44.250000,48.370000C44.980000,48.580000,45.190000,48.370000,45.390000,48.160000C45.590000,47.950000,45.500000,47.740000,45.500000,47.430000C45.404687,46.673494,45.770853,45.933289,46.430000,45.550000L46.220000,45.550000C45.823491,45.383915,45.495448,45.087618,45.290000,44.710000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path10"
        d="M52.150000,41.050000L52.250000,40.950000C52.896658,40.152378,53.249691,39.156824,53.250000,38.130000L52.250000,38.130000L52.250000,37.920000C52.085620,36.979797,51.651312,36.107707,51,35.410000C50.625955,36.003143,49.894688,36.263425,49.230000,36.040000C48.447312,35.781873,48.006578,34.953293,48.230000,34.160000C48.230000,34.050000,48.330000,33.950000,48.330000,33.840000C47.348996,33.835406,46.396050,34.167172,45.630000,34.780000L45.530000,34.890000L45.320000,34.780000C44.735034,34.546210,44.228656,34.150818,43.860000,33.640000C43.234569,34.119939,42.764904,34.773991,42.510000,35.520000L42.410000,35.720000L42.200000,35.720000C41.620941,35.724453,41.051501,35.868528,40.540000,36.140000C40.964660,37.161953,40.886964,38.323697,40.330000,39.280000C39.977767,39.821924,39.409494,40.186202,38.770000,40.280000C38.955074,40.783246,39.237065,41.245302,39.600000,41.640000L39.810000,41.850000L39.710000,42.060000C39.253139,42.971372,39.026533,43.980800,39.050000,45C39.456071,44.877256,39.876112,44.806689,40.300000,44.790000C40.005985,45.698921,40.119002,46.690548,40.610000,47.510000C40.610000,47.620000,40.720000,47.620000,40.720000,47.720000C41.169581,48.697999,41.312518,49.789202,41.130000,50.850000C41.481169,50.825540,41.813163,50.680734,42.070000,50.440000L42.170000,50.960000C42.228207,51.789234,42.644323,52.552113,43.310000,53.050000C43.520000,52.420000,43.940000,51.480000,44.870000,51.480000C45.288895,51.490757,45.692769,51.638259,46.020000,51.900000C47.237883,51.062424,48.092159,49.793520,48.410000,48.350000L48.510000,48.030000C48.866127,48.159824,49.202635,48.338173,49.510000,48.560000C50.900000,47.220000,51,44.290000,51,44.290000C51,44.290000,51.620000,44.500000,52.140000,44.710000C52.450734,43.618348,52.450734,42.461652,52.140000,41.370000ZM43.150000,39.170000L43.150000,39.070000L43.250000,39.070000L44.190000,39.490000C44.080000,39.490000,44.080000,39.590000,43.980000,39.690000C43.852593,39.857152,43.833745,40.083041,43.931688,40.268997C44.029631,40.454952,44.226570,40.567186,44.436479,40.556673C44.646388,40.546161,44.831127,40.414811,44.910000,40.220000C44.987538,40.132808,45.020720,40.014827,45,39.900000C45.394390,40.113141,45.598740,40.562709,45.500000,41C45.402374,41.425391,45.233310,41.831144,45,42.200000C44.766690,42.568856,44.580000,42.100000,44.790000,41.580000C45,41.060000,44.890000,40.950000,44.890000,40.950000C44.497384,41.001136,44.098623,40.927680,43.750000,40.740000C43.282047,40.360676,43.040599,39.768373,43.110000,39.170000ZM46.780000,45.860000C45.780000,46.380000,46.260000,47.740000,45.850000,48.370000C45.440000,49,45.020000,48.990000,44.190000,48.780000C43.360000,48.570000,43,48.260000,42.900000,47.530000C42.800000,46.800000,44.040000,45.860000,43.310000,44.920000C42.580000,43.980000,42.790000,43.670000,42.790000,43.670000C42.980544,43.834459,43.192467,43.972377,43.420000,44.080000C43.520000,44.080000,43.730000,44.290000,44.040000,44.400000C44.350000,44.510000,44.980000,44.500000,45.040000,43.980000C45.150000,43.770000,44.940000,43.560000,44.830000,43.460000C44.720000,43.360000,44.630000,43.350000,44.520000,43.250000C44.410000,43.150000,44.520000,42.720000,44.520000,42.720000C44.738296,43.045440,45.076012,43.271782,45.460000,43.350000C45.835842,43.488764,46.254057,43.452079,46.600000,43.250000C46.583779,43.462308,46.469048,43.654761,46.290000,43.770000C46.176895,43.755110,46.063084,43.791823,45.980000,43.870000C45.759335,43.867009,45.556772,43.991664,45.460000,44.190000C45.350000,44.710000,45.770000,45.020000,46.180000,45.130000C46.416997,45.199497,46.663045,45.233202,46.910000,45.230000C47.157547,45.245144,47.405645,45.211158,47.640000,45.130000C47.874355,45.048842,47.680000,45.440000,46.740000,45.860000ZM50,41C49.734750,41.529151,49.233482,41.900461,48.650000,42L48.540000,42C48.175357,41.957695,47.829390,41.815849,47.540000,41.590000C47.250610,41.364151,47.440000,41.590000,47.330000,42.210000C47.220000,42.830000,46.920000,42.730000,46.920000,42.730000C46.926350,42.272379,46.997042,41.817926,47.130000,41.380000C47.254821,40.978573,47.640910,40.717029,48.060000,40.750000C47.983044,40.833800,47.946520,40.947027,47.960000,41.060000C47.899381,41.272210,47.979321,41.499569,48.159409,41.627146C48.339498,41.754723,48.580502,41.754723,48.760591,41.627146C48.940679,41.499569,49.020619,41.272210,48.960000,41.060000C48.960000,40.960000,48.960000,40.850000,48.850000,40.850000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path11"
        d="M68.470000,46.170000L68.470000,40.170000C63.260841,40.076054,58.061309,40.654153,53,41.890000C53.182767,43.088715,53.041197,44.314504,52.590000,45.440000L51.960000,45.130000C51.879543,45.046891,51.764847,45.006193,51.650000,45.020000C51.517283,46.617209,50.859775,48.125611,49.780000,49.310000C49.531987,49.064708,49.252953,48.852911,48.950000,48.680000C48.493990,50.115374,47.580872,51.362131,46.350000,52.230000L45.930000,52.440000L45.620000,52.130000C45.437902,51.917991,45.169307,51.800250,44.890000,51.810000C44.270000,51.810000,44.060000,52.440000,43.960000,52.960000L43.750000,53.800000C43.490251,53.650950,43.245747,53.476783,43.020000,53.280000C42.407002,52.721308,41.972229,51.994367,41.770000,51.190000C41.369395,51.315894,40.945603,51.350071,40.530000,51.290000C40.643493,50.565871,40.677028,49.831459,40.630000,49.100000C37.340216,49.041283,34.078925,48.478061,30.960000,47.430000C30.130000,47.950000,29.090000,47.320000,28.890000,47.220000C28.480704,46.888704,28.248037,46.386439,28.260000,45.860000L28.260000,45.550000C28.052584,44.948561,27.434922,44.590744,26.810000,44.710000C26.553238,44.483774,26.198625,44.404552,25.870000,44.500000L25.450000,44.710000C25.830255,45.033378,26.148738,45.423011,26.390000,45.860000L26.700000,46.700000C26.300335,46.538922,25.970786,46.241265,25.770000,45.860000C25.227360,45.556994,24.550727,45.642079,24.100000,46.070000C23.755556,45.956261,23.377311,46.082342,23.170000,46.380000L22.750000,46.800000C23.246902,46.889743,23.712041,47.106808,24.100000,47.430000L24.940000,48.160000C24.276917,48.186947,23.716755,48.660613,23.580000,49.310000C23.270000,49.410000,22.960000,49.620000,22.960000,49.930000L22.860000,50.560000C23.652134,50.455959,24.451944,50.422494,25.250000,50.460000L27.530000,51.290000L30.130000,51.290000C31.368314,51.264642,32.435484,52.156796,32.630000,53.380000C34.319210,53.503073,35.972356,53.929910,37.510000,54.640000C39.053931,55.401566,40.459917,56.415498,41.670000,57.640000C42.166421,57.175025,42.612237,56.658817,43,56.100000C44.770000,56.520000,45.500000,56.720000,46.330000,56.830000C47.958655,55.480411,49.486089,54.013139,50.900000,52.440000C51.628709,51.806513,52.393309,51.215534,53.190000,50.670000C54.190507,50.534945,55.208185,50.716798,56.100000,51.190000C56.520000,50.670000,57.240000,49.930000,57.240000,49.930000C60.402393,47.354278,64.394231,46.017741,68.470000,46.170000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path12"
        d="M31.880000,32.490000C31.589601,31.943889,31.514663,31.308698,31.670000,30.710000C31.665635,30.452400,31.593183,30.200542,31.460000,29.980000C31.305973,29.794265,31.081004,29.681780,30.840000,29.670000L30.530000,29.670000L30.420000,29.350000C30.220240,28.850407,30.115120,28.318025,30.110000,27.780000C29.490000,27.470000,29.180000,27.160000,28.760000,26.950000L28.760000,26.220000L28.450000,26.220000C28.060250,26.225605,27.685101,26.071866,27.411372,25.794361C27.137642,25.516856,26.989056,25.139637,27,24.750000C27.019303,24.377934,27.167843,24.024268,27.420000,23.750000C27.547754,23.384764,27.421945,22.978930,27.110000,22.750000C27.091920,22.507842,26.980829,22.282075,26.800000,22.120000C26.686949,22.005654,26.539307,21.931833,26.380000,21.910000C26.370636,22.283365,26.296186,22.652232,26.160000,23L25.850000,23.630000C25.771237,23.504869,25.736077,23.357199,25.750000,23.210000C25.750000,23,25.750000,22.890000,25.850000,22.790000C25.850000,22.160000,25.540000,21.950000,25.120000,21.950000C25.010897,21.704184,24.768909,21.544159,24.500000,21.540000L24.080000,21.540000C24.244622,21.851931,24.352947,22.190447,24.400000,22.540000L24.400000,22.650000C24.255682,22.242634,23.889862,21.954648,23.460000,21.910000L23,21.910000C23.187685,22.247371,23.309834,22.617210,23.360000,23L23.360000,26.550000C23.880000,26.760000,24.710000,27.280000,25.020000,27.390000C25.344949,27.591639,25.541852,27.947578,25.540000,28.330000C25.557155,28.510491,25.518776,28.691917,25.430000,28.850000C27.010367,30.414828,28.753621,31.806079,30.630000,33C31.182208,33.086474,31.741419,33.119960,32.300000,33.100000C32.171492,32.888989,32.031273,32.685337,31.880000,32.490000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path13"
        d="M40.300000,47.840000C40.300000,47.740000,40.200000,47.740000,40.200000,47.640000C39.766621,46.956239,39.582915,46.143693,39.680000,45.340000C39.563956,45.326206,39.447541,45.362586,39.360000,45.440000L38.640000,45.650000L38.530000,44.920000C38.454477,44.139684,38.560579,43.352476,38.840000,42.620000C37.139449,42.418540,35.495006,41.885116,34,41.050000C33.854563,41.281548,33.679779,41.493306,33.480000,41.680000C32.196286,41.391479,30.967283,40.898527,29.840000,40.220000C29.625795,40.459134,29.329548,40.609042,29.010000,40.640000C28.381045,40.629177,27.875330,40.119026,27.870000,39.490000C27.862090,39.106055,28.060541,38.747315,28.390000,38.550000C28.492226,38.063033,28.285917,37.563131,27.870000,37.290000C27.875033,36.961094,27.717991,36.650749,27.450000,36.460000C27.182009,36.269251,27.140000,36.140000,26.930000,36.140000C26.931497,36.646379,26.825851,37.147347,26.620000,37.610000C26.310000,38.130000,26.200000,38.340000,26.200000,38.340000C26.118754,38.175827,26.084162,37.992491,26.100000,37.810000C26.121120,37.589876,26.193003,37.377650,26.310000,37.190000C26.310000,36.350000,25.890000,36.040000,25.310000,36.040000C25.178607,35.702326,24.841168,35.490919,24.480000,35.520000L23.850000,35.520000C24.069048,35.941492,24.211269,36.398631,24.270000,36.870000L24.270000,37.290000C24.112495,37.036441,23.838369,36.878725,23.540000,36.870000L22.920000,36.870000C23.129652,37.444124,23.267368,38.042011,23.330000,38.650000L23.330000,42.200000L28.330000,43.770000C29.094378,44.021720,29.602694,44.745562,29.580000,45.550000L29.580000,45.650000C31.119494,46.438676,32.717575,47.107329,34.360000,47.650000C36.419974,48.041540,38.505277,48.285494,40.600000,48.380000C40.530459,48.184690,40.429091,48.002227,40.300000,47.840000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
      <path
        id="ef-logo-loading-v3-01-path14"
        d="M57.240000,70.200000C57.140000,70.200000,56.520000,70.310000,56.520000,70.310000C56.319991,70.155564,56.109483,70.015225,55.890000,69.890000C55.056209,69.395363,54.317860,68.755235,53.710000,68C50.800000,68.210000,48.410000,68.310000,46.330000,68.310000C43.790496,68.328672,41.253229,68.154841,38.740000,67.790000C38.471489,67.872461,38.190413,67.906326,37.910000,67.890000C36.538266,67.868563,35.431437,66.761734,35.410000,65.390000C35.391750,65.141508,35.429335,64.892081,35.520000,64.660000C35.322324,63.917834,34.613859,63.429969,33.850000,63.510000C33.628134,63.185689,33.236900,63.021371,32.850000,63.090000L32.120000,63.300000C32.542244,63.739856,32.845149,64.280267,33,64.870000L33.110000,65.400000C32.667643,65.143264,32.333598,64.734591,32.170000,64.250000C31.557558,63.776357,30.702442,63.776357,30.090000,64.250000C29.707515,64.045653,29.234564,64.132775,28.950000,64.460000L28.430000,64.980000C29.039375,65.112872,29.587788,65.443326,29.990000,65.920000C30.119112,66.039003,30.224328,66.181553,30.300000,66.340000C29.915160,66.269252,29.524412,66.429459,29.300000,66.750000L28.890000,67.380000C29.528791,67.397194,30.145404,67.617913,30.650000,68.010000C32.211255,69.441370,33.920956,70.701855,35.750000,71.770000C36.270000,71.870000,37.310000,72.080000,38.030000,72.190000C38.367070,72.544348,38.617001,72.972314,38.760000,73.440000L42.710000,73.440000C44.067083,73.646297,45.210838,74.561302,45.710000,75.840000C50.204606,74.729848,54.462557,72.819360,58.280000,70.200000C57.940885,70.097670,57.579115,70.097670,57.240000,70.200000Z"
        fill="rgb(225,38,28)"
        stroke="none"
        strokeWidth="1"
      />
    </g>
    <g id="ef-logo-loading-v3-01-layer-2">
      <g id={animationId} transform="translate(45.669999,46.839997) rotate(0)">
        <path
          id="ef-logo-loading-v3-01-path15"
          d="M5.620000,46.840000C5.620000,24.720996,23.550996,6.790000,45.670000,6.790000C67.789004,6.790000,85.720000,24.720996,85.720000,46.840000C85.720000,68.959004,67.789004,86.890000,45.670000,86.890000"
          transform="translate(-45.669999,-46.839997)"
          fill="none"
          stroke="url(#ef-logo-loading-v3-01-path15-stroke)"
          strokeWidth="4"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeDashoffset="6"
        />
      </g>
    </g>
  </svg>
);

export const SportsSoccer = ({ color = 'currentColor', ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="sports_soccer">
      <mask
        id="mask0_14284_246"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect id="Bounding box" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_14284_246)">
        <path
          id="sports_soccer_2"
          d="M7.9979 14.6677C7.07568 14.6677 6.20902 14.4927 5.3979 14.1427C4.58679 13.7927 3.88124 13.3177 3.28124 12.7177C2.68124 12.1177 2.20624 11.4122 1.85624 10.601C1.50624 9.78993 1.33124 8.92326 1.33124 8.00104C1.33124 7.07882 1.50624 6.21215 1.85624 5.40104C2.20624 4.58993 2.68124 3.88437 3.28124 3.28437C3.88124 2.68437 4.58679 2.20937 5.3979 1.85937C6.20902 1.50937 7.07568 1.33437 7.9979 1.33437C8.92013 1.33437 9.78679 1.50937 10.5979 1.85937C11.409 2.20937 12.1146 2.68437 12.7146 3.28437C13.3146 3.88437 13.7896 4.58993 14.1396 5.40104C14.4896 6.21215 14.6646 7.07882 14.6646 8.00104C14.6646 8.92326 14.4896 9.78993 14.1396 10.601C13.7896 11.4122 13.3146 12.1177 12.7146 12.7177C12.1146 13.3177 11.409 13.7927 10.5979 14.1427C9.78679 14.4927 8.92013 14.6677 7.9979 14.6677ZM11.3312 6.33437L12.2312 6.03437L12.4979 5.13437C12.1423 4.60104 11.7146 4.14271 11.2146 3.75937C10.7146 3.37604 10.1646 3.08993 9.56457 2.90104L8.66457 3.53437V4.46771L11.3312 6.33437ZM4.66457 6.33437L7.33124 4.46771V3.53437L6.43124 2.90104C5.83124 3.08993 5.28124 3.37604 4.78124 3.75937C4.28124 4.14271 3.85346 4.60104 3.4979 5.13437L3.76457 6.03437L4.66457 6.33437ZM3.96457 11.4677L4.73124 11.401L5.23124 10.501L4.26457 7.60104L3.33124 7.26771L2.66457 7.76771C2.66457 8.48993 2.76457 9.14826 2.96457 9.74271C3.16457 10.3372 3.4979 10.9122 3.96457 11.4677ZM7.9979 13.3344C8.28679 13.3344 8.57013 13.3122 8.8479 13.2677C9.12568 13.2233 9.3979 13.1566 9.66457 13.0677L10.1312 12.0677L9.6979 11.3344H6.2979L5.86457 12.0677L6.33124 13.0677C6.5979 13.1566 6.87013 13.2233 7.1479 13.2677C7.42568 13.3122 7.70902 13.3344 7.9979 13.3344ZM6.4979 10.001H9.4979L10.4312 7.33437L7.9979 5.63437L5.5979 7.33437L6.4979 10.001ZM12.0312 11.4677C12.4979 10.9122 12.8312 10.3372 13.0312 9.74271C13.2312 9.14826 13.3312 8.48993 13.3312 7.76771L12.6646 7.30104L11.7312 7.60104L10.7646 10.501L11.2646 11.401L12.0312 11.4677Z"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

export const FilterLocationIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_15960_6"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" />
    </mask>
    <g mask="url(#mask0_15960_6)">
      <path d="M7.33334 15.3V13.9667C5.94446 13.8111 4.75279 13.2361 3.75835 12.2417C2.7639 11.2472 2.1889 10.0556 2.03335 8.66666H0.700012V7.33333H2.03335C2.1889 5.94444 2.7639 4.75277 3.75835 3.75833C4.75279 2.76389 5.94446 2.18889 7.33334 2.03333V0.699997H8.66668V2.03333C10.0556 2.18889 11.2472 2.76389 12.2417 3.75833C13.2361 4.75277 13.8111 5.94444 13.9667 7.33333H15.3V8.66666H13.9667C13.8111 10.0556 13.2361 11.2472 12.2417 12.2417C11.2472 13.2361 10.0556 13.8111 8.66668 13.9667V15.3H7.33334ZM8.00001 12.6667C9.2889 12.6667 10.3889 12.2111 11.3 11.3C12.2111 10.3889 12.6667 9.28889 12.6667 8C12.6667 6.71111 12.2111 5.61111 11.3 4.7C10.3889 3.78889 9.2889 3.33333 8.00001 3.33333C6.71112 3.33333 5.61112 3.78889 4.70001 4.7C3.7889 5.61111 3.33335 6.71111 3.33335 8C3.33335 9.28889 3.7889 10.3889 4.70001 11.3C5.61112 12.2111 6.71112 12.6667 8.00001 12.6667ZM8.00001 10.6667C7.26668 10.6667 6.6389 10.4056 6.11668 9.88333C5.59446 9.36111 5.33335 8.73333 5.33335 8C5.33335 7.26666 5.59446 6.63889 6.11668 6.11666C6.6389 5.59444 7.26668 5.33333 8.00001 5.33333C8.73335 5.33333 9.36112 5.59444 9.88335 6.11666C10.4056 6.63889 10.6667 7.26666 10.6667 8C10.6667 8.73333 10.4056 9.36111 9.88335 9.88333C9.36112 10.4056 8.73335 10.6667 8.00001 10.6667ZM8.00001 9.33333C8.36668 9.33333 8.68057 9.20277 8.94168 8.94166C9.20279 8.68055 9.33334 8.36666 9.33334 8C9.33334 7.63333 9.20279 7.31944 8.94168 7.05833C8.68057 6.79722 8.36668 6.66666 8.00001 6.66666C7.63335 6.66666 7.31946 6.79722 7.05835 7.05833C6.79723 7.31944 6.66668 7.63333 6.66668 8C6.66668 8.36666 6.79723 8.68055 7.05835 8.94166C7.31946 9.20277 7.63335 9.33333 8.00001 9.33333Z" />
    </g>
  </svg>
);
export const ToolTipIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.40001 10H7.60001V6.40001H6.40001V10ZM7.00002 5.20001C7.17002 5.20001 7.31252 5.14251 7.42752 5.02751C7.54251 4.91251 7.60001 4.77001 7.60001 4.60001C7.60001 4.43001 7.54251 4.28751 7.42752 4.17251C7.31252 4.05751 7.17002 4 7.00002 4C6.83002 4 6.68751 4.05751 6.57252 4.17251C6.45751 4.28751 6.40001 4.43001 6.40001 4.60001C6.40001 4.77001 6.45751 4.91251 6.57252 5.02751C6.68751 5.14251 6.83002 5.20001 7.00002 5.20001ZM7.00002 13C6.17001 13 5.39001 12.8425 4.66001 12.5275C3.93001 12.2125 3.29501 11.785 2.755 11.245C2.215 10.705 1.7875 10.07 1.4725 9.34002C1.1575 8.61002 1 7.83002 1 7.00002C1 6.17001 1.1575 5.39001 1.4725 4.66001C1.7875 3.93001 2.215 3.29501 2.755 2.755C3.29501 2.215 3.93001 1.7875 4.66001 1.4725C5.39001 1.1575 6.17001 1 7.00002 1C7.83002 1 8.61002 1.1575 9.34002 1.4725C10.07 1.7875 10.705 2.215 11.245 2.755C11.785 3.29501 12.2125 3.93001 12.5275 4.66001C12.8425 5.39001 13 6.17001 13 7.00002C13 7.83002 12.8425 8.61002 12.5275 9.34002C12.2125 10.07 11.785 10.705 11.245 11.245C10.705 11.785 10.07 12.2125 9.34002 12.5275C8.61002 12.8425 7.83002 13 7.00002 13ZM7.00002 11.8C8.34002 11.8 9.47502 11.335 10.405 10.405C11.335 9.47502 11.8 8.34002 11.8 7.00002C11.8 5.66001 11.335 4.52501 10.405 3.595C9.47502 2.665 8.34002 2.2 7.00002 2.2C5.66001 2.2 4.52501 2.665 3.595 3.595C2.665 4.52501 2.2 5.66001 2.2 7.00002C2.2 8.34002 2.665 9.47502 3.595 10.405C4.52501 11.335 5.66001 11.8 7.00002 11.8Z"
      fill={color}
    />
  </svg>
);

export const ToolTipCloseIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 6L11 11L16 16"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 16L11 11L6 6"
      stroke={color}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const ErrorIcon = ({ color = 'currentColor', ...props }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 9.75C6.68417 9.75 6.83854 9.68771 6.96313 9.56312C7.08771 9.43854 7.15 9.28417 7.15 9.1C7.15 8.91583 7.08771 8.76146 6.96313 8.63688C6.83854 8.51229 6.68417 8.45 6.5 8.45C6.31583 8.45 6.16146 8.51229 6.03688 8.63688C5.91229 8.76146 5.85 8.91583 5.85 9.1C5.85 9.28417 5.91229 9.43854 6.03688 9.56312C6.16146 9.68771 6.31583 9.75 6.5 9.75ZM5.85 7.15H7.15V3.25H5.85V7.15ZM6.5 13C5.60083 13 4.75583 12.8294 3.965 12.4881C3.17417 12.1469 2.48625 11.6838 1.90125 11.0988C1.31625 10.5138 0.853125 9.82583 0.511875 9.035C0.170625 8.24417 0 7.39917 0 6.5C0 5.60083 0.170625 4.75583 0.511875 3.965C0.853125 3.17417 1.31625 2.48625 1.90125 1.90125C2.48625 1.31625 3.17417 0.853125 3.965 0.511875C4.75583 0.170625 5.60083 0 6.5 0C7.39917 0 8.24417 0.170625 9.035 0.511875C9.82583 0.853125 10.5138 1.31625 11.0988 1.90125C11.6838 2.48625 12.1469 3.17417 12.4881 3.965C12.8294 4.75583 13 5.60083 13 6.5C13 7.39917 12.8294 8.24417 12.4881 9.035C12.1469 9.82583 11.6838 10.5138 11.0988 11.0988C10.5138 11.6838 9.82583 12.1469 9.035 12.4881C8.24417 12.8294 7.39917 13 6.5 13ZM6.5 11.7C7.95167 11.7 9.18125 11.1962 10.1887 10.1887C11.1962 9.18125 11.7 7.95167 11.7 6.5C11.7 5.04833 11.1962 3.81875 10.1887 2.81125C9.18125 1.80375 7.95167 1.3 6.5 1.3C5.04833 1.3 3.81875 1.80375 2.81125 2.81125C1.80375 3.81875 1.3 5.04833 1.3 6.5C1.3 7.95167 1.80375 9.18125 2.81125 10.1887C3.81875 11.1962 5.04833 11.7 6.5 11.7Z"
      fill="white"
    />
  </svg>
);
